(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core-js-ir.js', './kotlin-kotlin-stdlib-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core-js-ir.js'), require('./kotlin-kotlin-stdlib-js-ir.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json-js-ir'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-ir' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json-js-ir'.");
    }
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json-js-ir'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json-js-ir'.");
    }
    root['kotlinx-serialization-kotlinx-serialization-json-js-ir'] = factory(typeof this['kotlinx-serialization-kotlinx-serialization-json-js-ir'] === 'undefined' ? {} : this['kotlinx-serialization-kotlinx-serialization-json-js-ir'], this['kotlinx-serialization-kotlinx-serialization-core-js-ir'], this['kotlin-kotlin-stdlib-js-ir']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var protoOf = kotlin_kotlin.$_$.nd;
  var objectMeta = kotlin_kotlin.$_$.md;
  var VOID = kotlin_kotlin.$_$.mj;
  var setMetadataFor = kotlin_kotlin.$_$.od;
  var classMeta = kotlin_kotlin.$_$.zb;
  var Unit_getInstance = kotlin_kotlin.$_$.z4;
  var toString = kotlin_kotlin.$_$.sd;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.m1;
  var charSequenceGet = kotlin_kotlin.$_$.wb;
  var Char = kotlin_kotlin.$_$.mh;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.h2;
  var equals = kotlin_kotlin.$_$.cc;
  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var interfaceMeta = kotlin_kotlin.$_$.nc;
  var THROW_CCE = kotlin_kotlin.$_$.bi;
  var hashCode = kotlin_kotlin.$_$.lc;
  var joinToString = kotlin_kotlin.$_$.b8;
  var List = kotlin_kotlin.$_$.k5;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.e1;
  var Map = kotlin_kotlin.$_$.m5;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var getStringHashCode = kotlin_kotlin.$_$.kc;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.h;
  var lazy = kotlin_kotlin.$_$.bj;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g2;
  var toInt = kotlin_kotlin.$_$.qg;
  var toLong = kotlin_kotlin.$_$.vg;
  var toDouble = kotlin_kotlin.$_$.ng;
  var toLongOrNull = kotlin_kotlin.$_$.ug;
  var toDoubleOrNull = kotlin_kotlin.$_$.mg;
  var StringCompanionObject_getInstance = kotlin_kotlin.$_$.m4;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var toULongOrNull = kotlin_kotlin.$_$.yg;
  var Companion_getInstance = kotlin_kotlin.$_$.x4;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.n3;
  var ULong = kotlin_kotlin.$_$.ki;
  var isInterface = kotlin_kotlin.$_$.xc;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.p1;
  var lazy_0 = kotlin_kotlin.$_$.cj;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var KProperty1 = kotlin_kotlin.$_$.re;
  var getPropertyCallableRef = kotlin_kotlin.$_$.jc;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var toLong_0 = kotlin_kotlin.$_$.qd;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.d3;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.f3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.m3;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.o3;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.u2;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.w2;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.v3;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.x3;
  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var captureStack = kotlin_kotlin.$_$.tb;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q2;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var charSequenceLength = kotlin_kotlin.$_$.xb;
  var charSequenceSubSequence = kotlin_kotlin.$_$.yb;
  var coerceAtLeast = kotlin_kotlin.$_$.ce;
  var coerceAtMost = kotlin_kotlin.$_$.ee;
  var Companion_getInstance_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var singleOrNull = kotlin_kotlin.$_$.m9;
  var arrayIterator = kotlin_kotlin.$_$.rb;
  var emptyMap = kotlin_kotlin.$_$.f7;
  var getValue = kotlin_kotlin.$_$.t7;
  var fillArrayVal = kotlin_kotlin.$_$.ec;
  var copyOf = kotlin_kotlin.$_$.y6;
  var copyOf_0 = kotlin_kotlin.$_$.z6;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var DeepRecursiveFunction = kotlin_kotlin.$_$.ph;
  var invoke = kotlin_kotlin.$_$.ui;
  var CoroutineImpl = kotlin_kotlin.$_$.lb;
  var DeepRecursiveScope = kotlin_kotlin.$_$.qh;
  var Unit = kotlin_kotlin.$_$.ni;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.ua;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var getKClass = kotlin_kotlin.$_$.e;
  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p2;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var isObject = kotlin_kotlin.$_$.ad;
  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var ensureNotNull = kotlin_kotlin.$_$.ti;
  var contains = kotlin_kotlin.$_$.hf;
  var plus = kotlin_kotlin.$_$.ej;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var decodeSerializableElement$default = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var IllegalArgumentException = kotlin_kotlin.$_$.uh;
  var isFinite = kotlin_kotlin.$_$.wi;
  var isFinite_0 = kotlin_kotlin.$_$.vi;
  var decodeSequentially = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var decodeCollectionSize = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var toUInt = kotlin_kotlin.$_$.xg;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.e3;
  var toULong = kotlin_kotlin.$_$.zg;
  var toUByte = kotlin_kotlin.$_$.wg;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.v2;
  var toUShort = kotlin_kotlin.$_$.ah;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.w3;
  var decodeSerializableValue = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var objectCreate = kotlin_kotlin.$_$.ld;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r2;
  var toString_0 = kotlin_kotlin.$_$.p2;
  var encodeNotNullMark = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var beginCollection = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var encodeNullableSerializableValue = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.w4;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.v4;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.y4;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var setOf = kotlin_kotlin.$_$.l9;
  var numberToChar = kotlin_kotlin.$_$.hd;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.o2;
  var equals_0 = kotlin_kotlin.$_$.mf;
  var toByte = kotlin_kotlin.$_$.pd;
  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.k1;
  var ByteCompanionObject_getInstance = kotlin_kotlin.$_$.h4;
  var ShortCompanionObject_getInstance = kotlin_kotlin.$_$.l4;
  var toShort = kotlin_kotlin.$_$.rd;
  var single = kotlin_kotlin.$_$.bg;
  var emptySet = kotlin_kotlin.$_$.g7;
  var plus_0 = kotlin_kotlin.$_$.y8;
  var toList = kotlin_kotlin.$_$.da;
  var Enum = kotlin_kotlin.$_$.rh;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var last = kotlin_kotlin.$_$.l8;
  var removeLast = kotlin_kotlin.$_$.f9;
  var lastIndexOf = kotlin_kotlin.$_$.uf;
  var Long = kotlin_kotlin.$_$.vh;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.k2;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.t4;
  var charArray = kotlin_kotlin.$_$.vb;
  var indexOf = kotlin_kotlin.$_$.of;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.d1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.n;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Json, 'Json', classMeta);
  setMetadataFor(Default, 'Default', objectMeta, Json);
  setMetadataFor(JsonBuilder, 'JsonBuilder', classMeta);
  setMetadataFor(JsonImpl, 'JsonImpl', classMeta, Json);
  setMetadataFor(JsonClassDiscriminator, 'JsonClassDiscriminator', classMeta);
  setMetadataFor(JsonNames, 'JsonNames', classMeta);
  setMetadataFor(JsonConfiguration, 'JsonConfiguration', classMeta);
  setMetadataFor(JsonDecoder, 'JsonDecoder', interfaceMeta, VOID, [Decoder, CompositeDecoder]);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(JsonElement, 'JsonElement', classMeta, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(JsonArray, 'JsonArray', classMeta, JsonElement, [JsonElement, List], VOID, {0: JsonArraySerializer_getInstance});
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(JsonObject, 'JsonObject', classMeta, JsonElement, [JsonElement, Map], VOID, {0: JsonObjectSerializer_getInstance});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(JsonPrimitive, 'JsonPrimitive', classMeta, JsonElement, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  setMetadataFor(JsonLiteral, 'JsonLiteral', classMeta, JsonPrimitive);
  setMetadataFor(JsonNull, 'JsonNull', objectMeta, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, {0: JsonNull_getInstance});
  setMetadataFor(JsonElementSerializer, 'JsonElementSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonArrayDescriptor, 'JsonArrayDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonArraySerializer, 'JsonArraySerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonObjectDescriptor, 'JsonObjectDescriptor', objectMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonObjectSerializer, 'JsonObjectSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonNullSerializer, 'JsonNullSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(JsonLiteralSerializer, 'JsonLiteralSerializer', objectMeta, VOID, [KSerializer]);
  setMetadataFor(defer$1, VOID, classMeta, VOID, [SerialDescriptor]);
  setMetadataFor(JsonEncoder, 'JsonEncoder', interfaceMeta, VOID, [Encoder, CompositeEncoder]);
  setMetadataFor(Composer, 'Composer', classMeta);
  setMetadataFor(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', classMeta, Composer);
  setMetadataFor(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', classMeta, Composer);
  setMetadataFor(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', classMeta, Composer);
  setMetadataFor(JsonElementMarker, 'JsonElementMarker', classMeta);
  setMetadataFor(JsonException, 'JsonException', classMeta, SerializationException);
  setMetadataFor(JsonEncodingException, 'JsonEncodingException', classMeta, JsonException);
  setMetadataFor(JsonDecodingException, 'JsonDecodingException', classMeta, JsonException);
  setMetadataFor(Tombstone, 'Tombstone', objectMeta);
  setMetadataFor(JsonPath, 'JsonPath', classMeta);
  setMetadataFor(JsonTreeReader$readDeepRecursive$slambda, 'JsonTreeReader$readDeepRecursive$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [2]);
  setMetadataFor($readObjectCOROUTINE$0, '$readObjectCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor(JsonTreeReader, 'JsonTreeReader', classMeta, VOID, VOID, VOID, VOID, [0]);
  setMetadataFor(PolymorphismValidator, 'PolymorphismValidator', classMeta, VOID, [SerializersModuleCollector]);
  setMetadataFor(Key, 'Key', classMeta);
  setMetadataFor(DescriptorSchemaCache, 'DescriptorSchemaCache', classMeta);
  setMetadataFor(DiscriminatorHolder, 'DiscriminatorHolder', classMeta);
  setMetadataFor(StreamingJsonDecoder, 'StreamingJsonDecoder', classMeta, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
  setMetadataFor(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', classMeta, AbstractDecoder);
  setMetadataFor(StreamingJsonEncoder, 'StreamingJsonEncoder', classMeta, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  setMetadataFor(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', classMeta, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  setMetadataFor(JsonTreeDecoder, 'JsonTreeDecoder', classMeta, AbstractJsonTreeDecoder);
  setMetadataFor(JsonTreeListDecoder, 'JsonTreeListDecoder', classMeta, AbstractJsonTreeDecoder);
  setMetadataFor(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', classMeta, AbstractJsonTreeDecoder);
  setMetadataFor(JsonTreeMapDecoder, 'JsonTreeMapDecoder', classMeta, JsonTreeDecoder);
  setMetadataFor(WriteMode, 'WriteMode', classMeta, Enum);
  setMetadataFor(AbstractJsonLexer, 'AbstractJsonLexer', classMeta);
  setMetadataFor(CharMappings, 'CharMappings', objectMeta);
  setMetadataFor(StringJsonLexer, 'StringJsonLexer', classMeta, AbstractJsonLexer);
  setMetadataFor(JsonToStringWriter, 'JsonToStringWriter', classMeta);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.lfp_1 = configuration;
    this.mfp_1 = serializersModule;
    this.nfp_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).of9 = function () {
    return this.mfp_1;
  };
  protoOf(Json).ofp = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.dv();
    }
  };
  protoOf(Json).pfp = function (deserializer, string) {
    var lexer = new StringJsonLexer(string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.qf5(), null);
    var result = input.yf8(deserializer);
    lexer.dfq();
    return result;
  };
  function Json_0(from, builderAction) {
    from = from === VOID ? Default_getInstance() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.tg();
    return new JsonImpl(conf, builder.rfq_1);
  }
  function JsonBuilder(json) {
    this.efq_1 = json.lfp_1.sfq_1;
    this.ffq_1 = json.lfp_1.xfq_1;
    this.gfq_1 = json.lfp_1.tfq_1;
    this.hfq_1 = json.lfp_1.ufq_1;
    this.ifq_1 = json.lfp_1.vfq_1;
    this.jfq_1 = json.lfp_1.wfq_1;
    this.kfq_1 = json.lfp_1.yfq_1;
    this.lfq_1 = json.lfp_1.zfq_1;
    this.mfq_1 = json.lfp_1.afr_1;
    this.nfq_1 = json.lfp_1.bfr_1;
    this.ofq_1 = json.lfp_1.cfr_1;
    this.pfq_1 = json.lfp_1.dfr_1;
    this.qfq_1 = json.lfp_1.efr_1;
    this.rfq_1 = json.of9();
  }
  protoOf(JsonBuilder).tg = function () {
    if (this.mfq_1) {
      // Inline function 'kotlin.require' call
      var tmp0_require = this.nfq_1 === 'type';
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_require) {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        tmp$ret$0 = 'Class discriminator should not be specified when array polymorphism is specified';
        var message = tmp$ret$0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
    if (!this.jfq_1) {
      // Inline function 'kotlin.require' call
      var tmp1_require = this.kfq_1 === '    ';
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp1_require) {
        var tmp$ret$1;
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        tmp$ret$1 = 'Indent should not be specified when default printing mode is used';
        var message_0 = tmp$ret$1;
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    } else if (!(this.kfq_1 === '    ')) {
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var tmp2_all = this.kfq_1;
        var indexedObject = tmp2_all;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$2;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          tmp$ret$2 = ((equals(new Char(element), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(element), new Char(_Char___init__impl__6a9atx(9)))) ? true : equals(new Char(element), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(element), new Char(_Char___init__impl__6a9atx(10)));
          if (!tmp$ret$2) {
            tmp$ret$3 = false;
            break $l$block;
          }
        }
        tmp$ret$3 = true;
      }
      var allWhitespaces = tmp$ret$3;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!allWhitespaces) {
        var tmp$ret$4;
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        tmp$ret$4 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.kfq_1;
        var message_1 = tmp$ret$4;
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    }
    return new JsonConfiguration(this.efq_1, this.gfq_1, this.hfq_1, this.ifq_1, this.jfq_1, this.ffq_1, this.kfq_1, this.lfq_1, this.mfq_1, this.nfq_1, this.ofq_1, this.pfq_1, this.qfq_1);
  };
  function validateConfiguration($this) {
    if (equals($this.of9(), EmptySerializersModule()))
      return Unit_getInstance();
    var collector = new PolymorphismValidator($this.lfp_1.afr_1, $this.lfp_1.bfr_1);
    $this.of9().ufo(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    this.sfq_1 = encodeDefaults;
    this.tfq_1 = ignoreUnknownKeys;
    this.ufq_1 = isLenient;
    this.vfq_1 = allowStructuredMapKeys;
    this.wfq_1 = prettyPrint;
    this.xfq_1 = explicitNulls;
    this.yfq_1 = prettyPrintIndent;
    this.zfq_1 = coerceInputValues;
    this.afr_1 = useArrayPolymorphism;
    this.bfr_1 = classDiscriminator;
    this.cfr_1 = allowSpecialFloatingPointValues;
    this.dfr_1 = useAlternativeNames;
    this.efr_1 = namingStrategy;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.sfq_1 + ', ignoreUnknownKeys=' + this.tfq_1 + ', isLenient=' + this.ufq_1 + ', ' + ('allowStructuredMapKeys=' + this.vfq_1 + ', prettyPrint=' + this.wfq_1 + ', explicitNulls=' + this.xfq_1 + ', ') + ("prettyPrintIndent='" + this.yfq_1 + "', coerceInputValues=" + this.zfq_1 + ', useArrayPolymorphism=' + this.afr_1 + ', ') + ("classDiscriminator='" + this.bfr_1 + "', allowSpecialFloatingPointValues=" + this.cfr_1 + ', useAlternativeNames=' + this.dfr_1 + ', ') + ('namingStrategy=' + this.efr_1 + ')');
  };
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
    Companion_instance = this;
  }
  var Companion_instance;
  function Companion_getInstance_5() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function JsonElement() {
    Companion_getInstance_5();
  }
  function Companion_0() {
    Companion_instance_0 = this;
  }
  var Companion_instance_0;
  function Companion_getInstance_6() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function JsonArray(content) {
    Companion_getInstance_6();
    JsonElement.call(this);
    this.hfr_1 = content;
  }
  protoOf(JsonArray).l = function () {
    return this.hfr_1.l();
  };
  protoOf(JsonArray).ifr = function (element) {
    return this.hfr_1.q(element);
  };
  protoOf(JsonArray).q = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.ifr(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).jfr = function (elements) {
    return this.hfr_1.w1(elements);
  };
  protoOf(JsonArray).w1 = function (elements) {
    return this.jfr(elements);
  };
  protoOf(JsonArray).n = function (index) {
    return this.hfr_1.n(index);
  };
  protoOf(JsonArray).kfr = function (element) {
    return this.hfr_1.x(element);
  };
  protoOf(JsonArray).x = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.kfr(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).p = function () {
    return this.hfr_1.p();
  };
  protoOf(JsonArray).h = function () {
    return this.hfr_1.h();
  };
  protoOf(JsonArray).o = function (index) {
    return this.hfr_1.o(index);
  };
  protoOf(JsonArray).w = function (fromIndex, toIndex) {
    return this.hfr_1.w(fromIndex, toIndex);
  };
  protoOf(JsonArray).equals = function (other) {
    return equals(this.hfr_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.hfr_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.hfr_1, ',', '[', ']');
  };
  function Companion_1() {
    Companion_instance_1 = this;
  }
  var Companion_instance_1;
  function Companion_getInstance_7() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function JsonObject$toString$lambda(_name_for_destructuring_parameter_0__wldtmu) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.component1' call
    tmp$ret$0 = _name_for_destructuring_parameter_0__wldtmu.e1();
    var k = tmp$ret$0;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.component2' call
    tmp$ret$1 = _name_for_destructuring_parameter_0__wldtmu.f1();
    var v = tmp$ret$1;
    var tmp$ret$3;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$2;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
    printQuoted(tmp0_apply, k);
    tmp0_apply.ib(_Char___init__impl__6a9atx(58));
    tmp0_apply.ac(v);
    tmp$ret$2 = tmp0_apply;
    tmp$ret$3 = tmp$ret$2.toString();
    return tmp$ret$3;
  }
  function JsonObject(content) {
    Companion_getInstance_7();
    JsonElement.call(this);
    this.lfr_1 = content;
  }
  protoOf(JsonObject).d1 = function () {
    return this.lfr_1.d1();
  };
  protoOf(JsonObject).i3 = function () {
    return this.lfr_1.i3();
  };
  protoOf(JsonObject).l = function () {
    return this.lfr_1.l();
  };
  protoOf(JsonObject).j3 = function () {
    return this.lfr_1.j3();
  };
  protoOf(JsonObject).o1b = function (key) {
    return this.lfr_1.b3(key);
  };
  protoOf(JsonObject).b3 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.o1b((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).p1b = function (key) {
    return this.lfr_1.h3(key);
  };
  protoOf(JsonObject).h3 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.p1b((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).p = function () {
    return this.lfr_1.p();
  };
  protoOf(JsonObject).equals = function (other) {
    return equals(this.lfr_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.lfr_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.lfr_1.d1();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  function Companion_2() {
    Companion_instance_2 = this;
  }
  var Companion_instance_2;
  function Companion_getInstance_8() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function JsonPrimitive() {
    Companion_getInstance_8();
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.mfr();
  };
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.nfr_1 = isString;
    this.ofr_1 = coerceToInlineType;
    this.pfr_1 = toString(body);
    if (!(this.ofr_1 == null)) {
      // Inline function 'kotlin.require' call
      var tmp0_require = this.ofr_1.ff7();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!tmp0_require) {
        var tmp$ret$0;
        // Inline function 'kotlin.require.<anonymous>' call
        tmp$ret$0 = 'Failed requirement.';
        var message = tmp$ret$0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).mfr = function () {
    return this.pfr_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.nfr_1) {
      var tmp$ret$1;
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(tmp0_apply, this.pfr_1);
      tmp$ret$0 = tmp0_apply;
      tmp$ret$1 = tmp$ret$0.toString();
      tmp = tmp$ret$1;
    } else {
      tmp = this.pfr_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null ? true : !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (other instanceof JsonLiteral)
      other;
    else
      THROW_CCE();
    if (!(this.nfr_1 === other.nfr_1))
      return false;
    if (!(this.pfr_1 === other.pfr_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = this.nfr_1 | 0;
    result = imul(31, result) + getStringHashCode(this.pfr_1) | 0;
    return result;
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.rfr_1.f1();
  }
  function JsonNull$_anonymous__enib48() {
    return JsonNullSerializer_getInstance();
  }
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.qfr_1 = 'null';
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.rfr_1 = lazy(tmp_0, JsonNull$_anonymous__enib48);
  }
  protoOf(JsonNull).mfr = function () {
    return this.qfr_1;
  };
  protoOf(JsonNull).sfr = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(JsonNull).cfh = function (typeParamsSerializers) {
    return this.sfr();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull(_this__u8e3s4.mfr());
  }
  function get_int(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toInt(_this__u8e3s4.mfr());
  }
  function get_long(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLong(_this__u8e3s4.mfr());
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp$ret$2;
    // Inline function 'kotlin.text.toFloat' call
    var tmp1_toFloat = _this__u8e3s4.mfr();
    var tmp$ret$1;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp0_unsafeCast = toDouble(tmp1_toFloat);
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_unsafeCast;
    tmp$ret$1 = tmp$ret$0;
    tmp$ret$2 = tmp$ret$1;
    return tmp$ret$2;
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.mfr());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.mfr();
    }
    return tmp;
  }
  function get_longOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toLongOrNull(_this__u8e3s4.mfr());
  }
  function get_doubleOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDoubleOrNull(_this__u8e3s4.mfr());
  }
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$('Element ' + getKClassFromExpression(_this__u8e3s4) + ' is not a ' + element);
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (properties_initialized_JsonElement_kt_abxy8s) {
    } else {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_getInstance()));
    }
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.bf6('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.bf6('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.bf6('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.bf6('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.bf6('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_getInstance();
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().tfr_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().ufr_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().vfr_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().wfr_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().xfr_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.yfr_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).qf5 = function () {
    return this.yfr_1;
  };
  protoOf(JsonElementSerializer).zfr = function (encoder, value) {
    verify(encoder);
    var tmp0_subject = value;
    if (tmp0_subject instanceof JsonPrimitive) {
      encoder.rfa(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (tmp0_subject instanceof JsonObject) {
        encoder.rfa(JsonObjectSerializer_getInstance(), value);
      } else {
        if (tmp0_subject instanceof JsonArray) {
          encoder.rfa(JsonArraySerializer_getInstance(), value);
        }
      }
    }
  };
  protoOf(JsonElementSerializer).rf5 = function (encoder, value) {
    return this.zfr(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).sf5 = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.gfr();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.afs_1 = ListSerializer(JsonElementSerializer_getInstance()).qf5();
    this.bfs_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).df7 = function () {
    return this.afs_1.df7();
  };
  protoOf(JsonArrayDescriptor).ef7 = function () {
    return this.afs_1.ef7();
  };
  protoOf(JsonArrayDescriptor).ff7 = function () {
    return this.afs_1.ff7();
  };
  protoOf(JsonArrayDescriptor).zf6 = function () {
    return this.afs_1.zf6();
  };
  protoOf(JsonArrayDescriptor).gf7 = function () {
    return this.afs_1.gf7();
  };
  protoOf(JsonArrayDescriptor).hf7 = function (index) {
    return this.afs_1.hf7(index);
  };
  protoOf(JsonArrayDescriptor).if7 = function (index) {
    return this.afs_1.if7(index);
  };
  protoOf(JsonArrayDescriptor).jf7 = function (name) {
    return this.afs_1.jf7(name);
  };
  protoOf(JsonArrayDescriptor).kf7 = function (index) {
    return this.afs_1.kf7(index);
  };
  protoOf(JsonArrayDescriptor).lf7 = function (index) {
    return this.afs_1.lf7(index);
  };
  protoOf(JsonArrayDescriptor).qf6 = function () {
    return this.bfs_1;
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.xfr_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).qf5 = function () {
    return this.xfr_1;
  };
  protoOf(JsonArraySerializer).cfs = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).rf5(encoder, value);
  };
  protoOf(JsonArraySerializer).rf5 = function (encoder, value) {
    return this.cfs(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).sf5 = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).sf5(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.dfs_1 = MapSerializer(serializer(StringCompanionObject_getInstance()), JsonElementSerializer_getInstance()).qf5();
    this.efs_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).df7 = function () {
    return this.dfs_1.df7();
  };
  protoOf(JsonObjectDescriptor).ef7 = function () {
    return this.dfs_1.ef7();
  };
  protoOf(JsonObjectDescriptor).ff7 = function () {
    return this.dfs_1.ff7();
  };
  protoOf(JsonObjectDescriptor).zf6 = function () {
    return this.dfs_1.zf6();
  };
  protoOf(JsonObjectDescriptor).gf7 = function () {
    return this.dfs_1.gf7();
  };
  protoOf(JsonObjectDescriptor).hf7 = function (index) {
    return this.dfs_1.hf7(index);
  };
  protoOf(JsonObjectDescriptor).if7 = function (index) {
    return this.dfs_1.if7(index);
  };
  protoOf(JsonObjectDescriptor).jf7 = function (name) {
    return this.dfs_1.jf7(name);
  };
  protoOf(JsonObjectDescriptor).kf7 = function (index) {
    return this.dfs_1.kf7(index);
  };
  protoOf(JsonObjectDescriptor).lf7 = function (index) {
    return this.dfs_1.lf7(index);
  };
  protoOf(JsonObjectDescriptor).qf6 = function () {
    return this.efs_1;
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.wfr_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).qf5 = function () {
    return this.wfr_1;
  };
  protoOf(JsonObjectSerializer).ffs = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_getInstance()), JsonElementSerializer_getInstance()).rf5(encoder, value);
  };
  protoOf(JsonObjectSerializer).rf5 = function (encoder, value) {
    return this.ffs(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).sf5 = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_getInstance()), JsonElementSerializer_getInstance()).sf5(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.tfr_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).qf5 = function () {
    return this.tfr_1;
  };
  protoOf(JsonPrimitiveSerializer).gfs = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.rfa(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_getInstance();
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.rfa(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_getInstance();
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).rf5 = function (encoder, value) {
    return this.gfs(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).sf5 = function (decoder) {
    var result = asJsonDecoder(decoder).gfr();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + getKClassFromExpression(result), toString(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.ufr_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).qf5 = function () {
    return this.ufr_1;
  };
  protoOf(JsonNullSerializer).hfs = function (encoder, value) {
    verify(encoder);
    encoder.uf9();
  };
  protoOf(JsonNullSerializer).rf5 = function (encoder, value) {
    return this.hfs(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).sf5 = function (decoder) {
    verify_0(decoder);
    if (decoder.kf8()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.lf8();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.vfr_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).qf5 = function () {
    return this.vfr_1;
  };
  protoOf(JsonLiteralSerializer).ifs = function (encoder, value) {
    verify(encoder);
    if (value.nfr_1) {
      return encoder.dfa(value.pfr_1);
    }
    if (!(value.ofr_1 == null)) {
      return encoder.ffa(value.ofr_1).dfa(value.pfr_1);
    }
    var tmp0_safe_receiver = get_longOrNull(value);
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.zf9(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.pfr_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      var tmp$ret$2;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0 = encoder.ffa(serializer_0(Companion_getInstance()).qf5());
      var tmp$ret$1;
      // Inline function 'kotlin.ULong.toLong' call
      tmp$ret$1 = _ULong___get_data__impl__fggpzb(tmp1_safe_receiver);
      tmp_0.zf9(tmp$ret$1);
      return Unit_getInstance();
    }
    var tmp2_safe_receiver = get_doubleOrNull(value);
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp$ret$3;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.bfa(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = get_booleanOrNull(value);
    if (tmp3_safe_receiver == null)
      null;
    else {
      var tmp$ret$4;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.vf9(tmp3_safe_receiver);
    }
    encoder.dfa(value.pfr_1);
  };
  protoOf(JsonLiteralSerializer).rf5 = function (encoder, value) {
    return this.ifs(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).sf5 = function (decoder) {
    var result = asJsonDecoder(decoder).gfr();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + getKClassFromExpression(result), toString(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + getKClassFromExpression(_this__u8e3s4)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + getKClassFromExpression(_this__u8e3s4)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    var tmp$ret$0;
    // Inline function 'kotlin.getValue' call
    var tmp0_getValue = original$factory();
    tmp$ret$0 = $this.jfs_1.f1();
    return tmp$ret$0;
  }
  function defer$1($deferred) {
    this.jfs_1 = lazy_0($deferred);
  }
  protoOf(defer$1).qf6 = function () {
    return _get_original__l7ku1m(this).qf6();
  };
  protoOf(defer$1).gf7 = function () {
    return _get_original__l7ku1m(this).gf7();
  };
  protoOf(defer$1).ef7 = function () {
    return _get_original__l7ku1m(this).ef7();
  };
  protoOf(defer$1).kf7 = function (index) {
    return _get_original__l7ku1m(this).kf7(index);
  };
  protoOf(defer$1).jf7 = function (name) {
    return _get_original__l7ku1m(this).jf7(name);
  };
  protoOf(defer$1).hf7 = function (index) {
    return _get_original__l7ku1m(this).hf7(index);
  };
  protoOf(defer$1).if7 = function (index) {
    return _get_original__l7ku1m(this).if7(index);
  };
  protoOf(defer$1).lf7 = function (index) {
    return _get_original__l7ku1m(this).lf7(index);
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original__l7ku1m(receiver);
    }, null);
  }
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.kfs_1 = writer;
    this.lfs_1 = true;
  }
  protoOf(Composer).mfs = function () {
    this.lfs_1 = true;
  };
  protoOf(Composer).nfs = function () {
    return Unit_getInstance();
  };
  protoOf(Composer).ofs = function () {
    this.lfs_1 = false;
  };
  protoOf(Composer).pfs = function () {
    return Unit_getInstance();
  };
  protoOf(Composer).qfs = function (v) {
    return this.kfs_1.rfs(v);
  };
  protoOf(Composer).sfs = function (v) {
    return this.kfs_1.tfs(v);
  };
  protoOf(Composer).ufs = function (v) {
    return this.kfs_1.tfs(v.toString());
  };
  protoOf(Composer).vfs = function (v) {
    return this.kfs_1.tfs(v.toString());
  };
  protoOf(Composer).wfs = function (v) {
    return this.kfs_1.xfs(toLong_0(v));
  };
  protoOf(Composer).yfs = function (v) {
    return this.kfs_1.xfs(toLong_0(v));
  };
  protoOf(Composer).zfs = function (v) {
    return this.kfs_1.xfs(toLong_0(v));
  };
  protoOf(Composer).aft = function (v) {
    return this.kfs_1.xfs(v);
  };
  protoOf(Composer).bft = function (v) {
    return this.kfs_1.tfs(v.toString());
  };
  protoOf(Composer).cft = function (value) {
    return this.kfs_1.dft(value);
  };
  function Composer_0(sb, json) {
    return json.lfp_1.wfq_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.gft_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).zfs = function (v) {
    if (this.gft_1) {
      var tmp$ret$0;
      // Inline function 'kotlin.toUInt' call
      tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.cft(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.toUInt' call
      tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.sfs(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).aft = function (v) {
    if (this.gft_1) {
      var tmp$ret$0;
      // Inline function 'kotlin.toULong' call
      tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.cft(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.toULong' call
      tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.sfs(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).wfs = function (v) {
    if (this.gft_1) {
      var tmp$ret$0;
      // Inline function 'kotlin.toUByte' call
      tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.cft(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.toUByte' call
      tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.sfs(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).yfs = function (v) {
    if (this.gft_1) {
      var tmp$ret$0;
      // Inline function 'kotlin.toUShort' call
      tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.cft(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.toUShort' call
      tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.sfs(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.jft_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).cft = function (value) {
    if (this.jft_1) {
      protoOf(Composer).cft.call(this, value);
    } else {
      protoOf(Composer).sfs.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.mft_1 = json;
    this.nft_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).mfs = function () {
    this.lfs_1 = true;
    var tmp0_this = this;
    var tmp1 = tmp0_this.nft_1;
    tmp0_this.nft_1 = tmp1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).nfs = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this.nft_1;
    tmp0_this.nft_1 = tmp1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).ofs = function () {
    this.lfs_1 = false;
    this.sfs('\n');
    // Inline function 'kotlin.repeat' call
    var tmp0_repeat = this.nft_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.sfs(this.mft_1.lfp_1.yfq_1);
      }
       while (inductionVariable < tmp0_repeat);
  };
  protoOf(ComposerWithPrettyPrint).pfs = function () {
    this.qfs(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.pft_1 = !descriptor.lf7(index) ? descriptor.if7(index).zf6() : false;
    return $this.pft_1;
  }
  function JsonElementMarker$readIfAbsent$ref($boundThis) {
    var l = function (p0, p1) {
      return readIfAbsent($boundThis, p0, p1);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.oft_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.pft_1 = false;
  }
  protoOf(JsonElementMarker).vfe = function (index) {
    this.oft_1.vfe(index);
  };
  protoOf(JsonElementMarker).wfe = function () {
    return this.oft_1.wfe();
  };
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.qft('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, get_specialFlowingValuesHint());
  }
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.qf6() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.gf7() + "'.\n") + get_allowStructuredMapKeysHint());
  }
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + minify(input, offset));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function UnknownKeyException(key, input) {
    return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + (get_ignoreUnknownKeysHint() + '\n') + ('Current input: ' + minify(input)));
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output)));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + (get_specialFlowingValuesHint() + '\n') + ('Current output: ' + minify(output));
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      var tmp$ret$0;
      // Inline function 'kotlin.text.substring' call
      var tmp0_substring = charSequenceLength(_this__u8e3s4);
      tmp$ret$0 = toString(charSequenceSubSequence(_this__u8e3s4, start, tmp0_substring));
      return '.....' + tmp$ret$0;
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp1_substring = coerceAtLeast(start_0, 0);
    var tmp2_substring = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    tmp$ret$1 = toString(charSequenceSubSequence(_this__u8e3s4, tmp1_substring, tmp2_substring));
    return prefix + tmp$ret$1 + suffix;
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
    var index = _this__u8e3s4.jf7(name);
    Companion_getInstance_0();
    if (!(index === -3))
      return index;
    if (!json.lfp_1.dfr_1)
      return index;
    return getJsonNameIndex$getJsonNameIndexSlowPath(json, _this__u8e3s4, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    Companion_getInstance_0();
    if (index === -3)
      throw SerializationException_init_$Create$(_this__u8e3s4.qf6() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.kf7(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.gf7(), CLASS_getInstance()) ? json.lfp_1.efr_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.sft(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.sft(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap_init_$Create$();
    var builder = tmp$ret$0;
    var strategy = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.ef7();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$2;
        // Inline function 'kotlin.collections.filterIsInstance' call
        var tmp1_filterIsInstance = _this__u8e3s4.hf7(i);
        var tmp$ret$1;
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var tmp0_filterIsInstanceTo = ArrayList_init_$Create$();
        var tmp0_iterator = tmp1_filterIsInstance.h();
        while (tmp0_iterator.j()) {
          var element = tmp0_iterator.k();
          if (element instanceof JsonNames) {
            tmp0_filterIsInstanceTo.b(element);
          }
        }
        tmp$ret$1 = tmp0_filterIsInstanceTo;
        tmp$ret$2 = tmp$ret$1;
        var tmp1_safe_receiver = singleOrNull(tmp$ret$2);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.tft_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var tmp0_iterator_0 = arrayIterator(tmp2_safe_receiver);
          while (tmp0_iterator_0.j()) {
            var element_0 = tmp0_iterator_0.k();
            // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, element_0, i);
          }
        }
        var tmp3_safe_receiver = strategy;
        if (tmp3_safe_receiver == null)
          null;
        else {
          var tmp$ret$3;
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp3_safe_receiver.uft(_this__u8e3s4, i, _this__u8e3s4.kf7(i)), i);
          tmp$ret$3 = Unit_getInstance();
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp;
    if (builder.p()) {
      var tmp$ret$4;
      // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
      tmp$ret$4 = emptyMap();
      tmp = tmp$ret$4;
    } else {
      tmp = builder;
    }
    tmp$ret$5 = tmp;
    return tmp$ret$5;
  }
  function getJsonNameIndex$getJsonNameIndexSlowPath($json, $this_getJsonNameIndex, $name) {
    var tmp0_elvis_lhs = deserializationNamesMap($json, $this_getJsonNameIndex).h3($name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      Companion_getInstance_0();
      tmp = -3;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    var tmp$ret$1;
    // Inline function 'kotlin.collections.contains' call
    var tmp$ret$0;
    // Inline function 'kotlin.collections.containsKey' call
    tmp$ret$0 = (isInterface(_this__u8e3s4, Map) ? _this__u8e3s4 : THROW_CCE()).b3(name);
    tmp$ret$1 = tmp$ret$0;
    if (tmp$ret$1) {
      throw new JsonException("The suggested name '" + name + "' for property " + $this_buildDeserializationNamesMap.kf7(index) + ' is already one of the names for property ' + ($this_buildDeserializationNamesMap.kf7(getValue(_this__u8e3s4, name)) + ' in ' + $this_buildDeserializationNamesMap));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.e5(name, index);
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.ef7();
      var tmp$ret$0;
      // Inline function 'kotlin.arrayOfNulls' call
      tmp$ret$0 = fillArrayVal(Array(tmp_0), null);
      var tmp_1 = tmp$ret$0;
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var tmp$ret$1;
        // Inline function 'kotlinx.serialization.json.internal.serializationNamesIndices.<anonymous>.<anonymous>' call
        var baseName = $this_serializationNamesIndices.kf7(tmp_2);
        tmp$ret$1 = $strategy.uft($this_serializationNamesIndices, tmp_2, baseName);
        tmp_1[tmp_2] = tmp$ret$1;
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (properties_initialized_JsonNamesMap_kt_ljpf42) {
    } else {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function Tombstone() {
    Tombstone_instance = this;
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    if (Tombstone_instance == null)
      new Tombstone();
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.xft_1, 2);
    $this.vft_1 = copyOf($this.vft_1, newSize);
    $this.wft_1 = copyOf_0($this.wft_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp$ret$0 = fillArrayVal(Array(8), null);
    tmp.vft_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = 8;
    var tmp_3 = new Int32Array(tmp_2);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      var tmp$ret$1;
      // Inline function 'kotlinx.serialization.json.internal.JsonPath.indicies.<anonymous>' call
      tmp$ret$1 = -1;
      tmp_3[tmp_4] = tmp$ret$1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.wft_1 = tmp_3;
    this.xft_1 = -1;
  }
  protoOf(JsonPath).yft = function (sd) {
    var tmp0_this = this;
    tmp0_this.xft_1 = tmp0_this.xft_1 + 1 | 0;
    var depth = tmp0_this.xft_1;
    if (depth === this.vft_1.length) {
      resize(this);
    }
    this.vft_1[depth] = sd;
  };
  protoOf(JsonPath).zft = function (index) {
    this.wft_1[this.xft_1] = index;
  };
  protoOf(JsonPath).afu = function (key) {
    var tmp;
    if (!(this.wft_1[this.xft_1] === -2)) {
      var tmp0_this = this;
      tmp0_this.xft_1 = tmp0_this.xft_1 + 1 | 0;
      tmp = tmp0_this.xft_1 === this.vft_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.vft_1[this.xft_1] = key;
    this.wft_1[this.xft_1] = -2;
  };
  protoOf(JsonPath).bfu = function () {
    if (this.wft_1[this.xft_1] === -2) {
      this.vft_1[this.xft_1] = Tombstone_getInstance();
    }
  };
  protoOf(JsonPath).cfu = function () {
    var depth = this.xft_1;
    if (this.wft_1[depth] === -2) {
      this.wft_1[depth] = -1;
      var tmp0_this = this;
      var tmp1 = tmp0_this.xft_1;
      tmp0_this.xft_1 = tmp1 - 1 | 0;
    }
    if (!(this.xft_1 === -1)) {
      var tmp2_this = this;
      var tmp3 = tmp2_this.xft_1;
      tmp2_this.xft_1 = tmp3 - 1 | 0;
    }
  };
  protoOf(JsonPath).dfu = function () {
    var tmp$ret$1;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    tmp0_apply.bc('$');
    // Inline function 'kotlin.repeat' call
    var tmp0_repeat = this.xft_1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.vft_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.gf7(), LIST_getInstance())) {
            if (!(this.wft_1[index] === -1)) {
              tmp0_apply.bc('[');
              tmp0_apply.ac(this.wft_1[index]);
              tmp0_apply.bc(']');
            }
          } else {
            var idx = this.wft_1[index];
            if (idx >= 0) {
              tmp0_apply.bc('.');
              tmp0_apply.bc(element.kf7(idx));
            }
          }
        } else {
          if (!(element === Tombstone_getInstance())) {
            tmp0_apply.bc('[');
            tmp0_apply.bc("'");
            tmp0_apply.ac(element);
            tmp0_apply.bc("'");
            tmp0_apply.bc(']');
          }
        }
      }
       while (inductionVariable < tmp0_repeat);
    tmp$ret$0 = tmp0_apply;
    tmp$ret$1 = tmp$ret$0.toString();
    return tmp$ret$1;
  };
  protoOf(JsonPath).toString = function () {
    return this.dfu();
  };
  function encodeByWriter(_this__u8e3s4, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    var tmp$ret$0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp0_arrayOfNulls = values().length;
    tmp$ret$0 = fillArrayVal(Array(tmp0_arrayOfNulls), null);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, _this__u8e3s4, tmp, tmp$ret$0);
    encoder.rfa(serializer, value);
  }
  function readObject($this) {
    var tmp$ret$2;
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.mfu_1.pfu(get_TC_BEGIN_OBJ());
    if ($this.mfu_1.qfu() === get_TC_COMMA()) {
      $this.mfu_1.qft('Unexpected leading comma');
    }
    var tmp$ret$0;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp$ret$0 = LinkedHashMap_init_$Create$();
    var result = tmp$ret$0;
    $l$loop: while ($this.mfu_1.rfu()) {
      var key = $this.nfu_1 ? $this.mfu_1.tfu() : $this.mfu_1.sfu();
      $this.mfu_1.pfu(get_TC_COLON());
      var tmp$ret$1;
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
      tmp$ret$1 = $this.m3j();
      var element = tmp$ret$1;
      // Inline function 'kotlin.collections.set' call
      result.e5(key, element);
      lastToken = $this.mfu_1.ufu();
      var tmp0_subject = lastToken;
      if (tmp0_subject === get_TC_COMMA())
      ;
      else if (tmp0_subject === get_TC_END_OBJ())
        break $l$loop;
      else {
        $this.mfu_1.qft('Expected end of the object or comma');
      }
    }
    if (lastToken === get_TC_BEGIN_OBJ()) {
      $this.mfu_1.pfu(get_TC_END_OBJ());
    } else if (lastToken === get_TC_COMMA()) {
      $this.mfu_1.qft('Unexpected trailing comma');
    }
    tmp$ret$2 = new JsonObject(result);
    return tmp$ret$2;
  }
  function readObject_0(_this__u8e3s4, $this, $completion) {
    var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
    tmp.a8_1 = Unit_getInstance();
    tmp.b8_1 = null;
    return tmp.f8();
  }
  function readArray($this) {
    var lastToken = $this.mfu_1.ufu();
    if ($this.mfu_1.qfu() === get_TC_COMMA()) {
      $this.mfu_1.qft('Unexpected leading comma');
    }
    var tmp$ret$0;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    var result = tmp$ret$0;
    while ($this.mfu_1.rfu()) {
      var element = $this.m3j();
      result.b(element);
      lastToken = $this.mfu_1.ufu();
      if (!(lastToken === get_TC_COMMA())) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var tmp0_require = $this.mfu_1;
        var tmp1_require = lastToken === get_TC_END_LIST();
        var tmp2_require = tmp0_require.zfp_1;
        if (!tmp1_require) {
          var tmp$ret$1;
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
          tmp$ret$1 = 'Expected end of the array or comma';
          tmp0_require.qft(tmp$ret$1, tmp2_require);
        }
      }
    }
    if (lastToken === get_TC_BEGIN_LIST()) {
      $this.mfu_1.pfu(get_TC_END_LIST());
    } else if (lastToken === get_TC_COMMA()) {
      $this.mfu_1.qft('Unexpected trailing comma');
    }
    return new JsonArray(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.nfu_1 ? true : !isString) {
      tmp = $this.mfu_1.tfu();
    } else {
      tmp = $this.mfu_1.sfu();
    }
    var string = tmp;
    if (!isString ? string === get_NULL() : false)
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_getInstance());
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.qfv_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).vfv = function ($this$$receiver, it, $completion) {
    var tmp = this.wfv($this$$receiver, it, $completion);
    tmp.a8_1 = Unit_getInstance();
    tmp.b8_1 = null;
    return tmp.f8();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).yc = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.vfv(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).f8 = function () {
    var suspendResult = this.a8_1;
    $sm: do
      try {
        var tmp = this.y7_1;
        switch (tmp) {
          case 0:
            this.z7_1 = 3;
            this.tfv_1 = this.qfv_1.mfu_1.qfu();
            if (this.tfv_1 === get_TC_STRING()) {
              this.ufv_1 = readValue(this.qfv_1, true);
              this.y7_1 = 2;
              continue $sm;
            } else {
              if (this.tfv_1 === get_TC_OTHER()) {
                this.ufv_1 = readValue(this.qfv_1, false);
                this.y7_1 = 2;
                continue $sm;
              } else {
                if (this.tfv_1 === get_TC_BEGIN_OBJ()) {
                  this.y7_1 = 1;
                  suspendResult = readObject_0(this.rfv_1, this.qfv_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.tfv_1 === get_TC_BEGIN_LIST()) {
                    this.ufv_1 = readArray(this.qfv_1);
                    this.y7_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.qfv_1.mfu_1.qft("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.ufv_1 = suspendResult;
            this.y7_1 = 2;
            continue $sm;
          case 2:
            return this.ufv_1;
          case 3:
            throw this.b8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z7_1 === 3) {
          throw e;
        } else {
          this.y7_1 = this.z7_1;
          this.b8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).wfv = function ($this$$receiver, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.qfv_1, completion);
    i.rfv_1 = $this$$receiver;
    i.sfv_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    var l = function ($this$$receiver, it, $completion) {
      return i.vfv($this$$receiver, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dfv_1 = _this__u8e3s4;
    this.efv_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$0).f8 = function () {
    var suspendResult = this.a8_1;
    $sm: do
      try {
        var tmp = this.y7_1;
        switch (tmp) {
          case 0:
            this.z7_1 = 5;
            this.ffv_1 = this.dfv_1.mfu_1.pfu(get_TC_BEGIN_OBJ());
            if (this.dfv_1.mfu_1.qfu() === get_TC_COMMA()) {
              this.dfv_1.mfu_1.qft('Unexpected leading comma');
            }

            var tmp_0 = this;
            tmp_0.gfv_1 = LinkedHashMap_init_$Create$();
            this.y7_1 = 1;
            continue $sm;
          case 1:
            if (!this.dfv_1.mfu_1.rfu()) {
              this.y7_1 = 4;
              continue $sm;
            }

            this.hfv_1 = this.dfv_1.nfu_1 ? this.dfv_1.mfu_1.tfu() : this.dfv_1.mfu_1.sfu();
            this.dfv_1.mfu_1.pfu(get_TC_COLON());
            ;
            this.y7_1 = 2;
            suspendResult = this.efv_1.qc(Unit_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            this.gfv_1.e5(this.hfv_1, element);
            ;
            this.ffv_1 = this.dfv_1.mfu_1.ufu();
            var tmp0_subject = this.ffv_1;
            if (tmp0_subject === get_TC_COMMA()) {
              this.y7_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === get_TC_END_OBJ()) {
                this.y7_1 = 4;
                continue $sm;
              } else {
                this.dfv_1.mfu_1.qft('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.y7_1 = 1;
            continue $sm;
          case 4:
            if (this.ffv_1 === get_TC_BEGIN_OBJ()) {
              this.dfv_1.mfu_1.pfu(get_TC_END_OBJ());
            } else if (this.ffv_1 === get_TC_COMMA()) {
              this.dfv_1.mfu_1.qft('Unexpected trailing comma');
            }

            return new JsonObject(this.gfv_1);
          case 5:
            throw this.b8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.z7_1 === 5) {
          throw e;
        } else {
          this.y7_1 = this.z7_1;
          this.b8_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.mfu_1 = lexer;
    this.nfu_1 = configuration.ufq_1;
    this.ofu_1 = 0;
  }
  protoOf(JsonTreeReader).m3j = function () {
    var token = this.mfu_1.qfu();
    var tmp;
    if (token === get_TC_STRING()) {
      tmp = readValue(this, true);
    } else if (token === get_TC_OTHER()) {
      tmp = readValue(this, false);
    } else if (token === get_TC_BEGIN_OBJ()) {
      var tmp_0;
      var tmp0_this = this;
      tmp0_this.ofu_1 = tmp0_this.ofu_1 + 1 | 0;
      if (tmp0_this.ofu_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      var tmp1_this = this;
      tmp1_this.ofu_1 = tmp1_this.ofu_1 - 1 | 0;
      tmp = result;
    } else if (token === get_TC_BEGIN_LIST()) {
      tmp = readArray(this);
    } else {
      this.mfu_1.qft('Cannot begin reading element, unexpected token: ' + token);
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var tmp0_iterator = _this__u8e3s4.df7().h();
    while (tmp0_iterator.j()) {
      var annotation = tmp0_iterator.k();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.xfv_1;
    }
    return json.lfp_1.bfr_1;
  }
  function decodeSerializableValuePolymorphic(_this__u8e3s4, deserializer) {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.ffr().lfp_1.afr_1;
    }
    if (tmp) {
      return deserializer.sf5(_this__u8e3s4);
    }
    var discriminator = classDiscriminator(deserializer.qf5(), _this__u8e3s4.ffr());
    var tmp$ret$0;
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var tmp0_cast = _this__u8e3s4.gfr();
    var tmp1_cast = deserializer.qf5();
    if (!(tmp0_cast instanceof JsonObject)) {
      throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + tmp1_cast.qf6() + ', but had ' + getKClassFromExpression(tmp0_cast));
    }
    tmp$ret$0 = tmp0_cast;
    var jsonTree = tmp$ret$0;
    var tmp0_safe_receiver = jsonTree.p1b(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.mfr();
    var tmp2_elvis_lhs = deserializer.gf6(_this__u8e3s4, type);
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      throwSerializerNotFound(type, jsonTree);
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var actualSerializer = tmp_0;
    var tmp_1 = _this__u8e3s4.ffr();
    return readPolymorphicJson(tmp_1, discriminator, jsonTree, isInterface(actualSerializer, DeserializationStrategy) ? actualSerializer : THROW_CCE());
  }
  function throwSerializerNotFound(type, jsonTree) {
    var suffix = type == null ? "missing class discriminator ('null')" : "class discriminator '" + type + "'";
    throw JsonDecodingException_0(-1, 'Polymorphic serializer was not found for ' + suffix, jsonTree.toString());
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_getInstance();
    if (jsonCachedSerialNames(actualSerializer.qf5()).q(classDiscriminator)) {
      var baseName = serializer.qf5().qf6();
      var actualName = actualSerializer.qf5().qf6();
      // Inline function 'kotlin.error' call
      var tmp0_error = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString(tmp0_error));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$("Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead");
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$("Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead");
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      throw IllegalStateException_init_$Create$('Actual serializer for polymorphic cannot be polymorphic itself');
    }
  }
  function validateIfSealed$accessor$1ad0flx(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor.gf7();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.zi() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.yfv_1)
      return Unit_getInstance();
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) ? true : equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.zi() + ' of kind ' + kind + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.ef7();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.kf7(i);
        if (name === $this.zfv_1) {
          throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + actualClass + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this.yfv_1 = useArrayPolymorphism;
    this.zfv_1 = discriminator;
  }
  protoOf(PolymorphismValidator).cfp = function (kClass, provider) {
  };
  protoOf(PolymorphismValidator).ffp = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.qf5();
    checkKind_0(this, descriptor, actualClass);
    if (!this.yfv_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(PolymorphismValidator).gfp = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(PolymorphismValidator).hfp = function (baseClass, defaultDeserializerProvider) {
  };
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.rft_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).afw = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    var tmp$ret$1;
    // Inline function 'kotlin.collections.getOrPut' call
    var tmp0_getOrPut = this.rft_1;
    var value_0 = tmp0_getOrPut.h3(descriptor);
    var tmp;
    if (value_0 == null) {
      var tmp$ret$0;
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      tmp$ret$0 = createMapForCache(2);
      var answer = tmp$ret$0;
      tmp0_getOrPut.e5(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    tmp$ret$1 = tmp;
    var tmp1_set = tmp$ret$1;
    var tmp2_set = key instanceof Key ? key : THROW_CCE();
    var tmp3_set = isObject(value) ? value : THROW_CCE();
    tmp1_set.e5(tmp2_set, tmp3_set);
  };
  protoOf(DescriptorSchemaCache).sft = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.bfw(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$0;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.afw(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).bfw = function (descriptor, key) {
    var tmp0_safe_receiver = this.rft_1.h3(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.h3(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return isObject(tmp_0) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.cfw_1 = discriminatorToSkip;
  }
  function trySkip(_this__u8e3s4, $this, unknownKey) {
    if (_this__u8e3s4 == null)
      return false;
    if (_this__u8e3s4.cfw_1 === unknownKey) {
      _this__u8e3s4.cfw_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    $l$loop: while (true) {
      var tmp = $this.qf9(descriptor);
      Companion_getInstance_0();
      if (!!(tmp === -1)) {
        break $l$loop;
      }
    }
  }
  function checkLeadingComma($this) {
    if ($this.tfp_1.qfu() === get_TC_COMMA()) {
      $this.tfp_1.qft('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.vfp_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.vfp_1 === -1)) {
        hasComma = $this.tfp_1.efw();
      }
    } else {
      $this.tfp_1.dfw(get_COLON());
    }
    var tmp;
    if ($this.tfp_1.rfu()) {
      if (decodingKey) {
        if ($this.vfp_1 === -1) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var tmp0_require = $this.tfp_1;
          var tmp1_require = !hasComma;
          var tmp2_require = tmp0_require.zfp_1;
          if (!tmp1_require) {
            var tmp$ret$0;
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            tmp$ret$0 = 'Unexpected trailing comma';
            tmp0_require.qft(tmp$ret$0, tmp2_require);
          }
        } else {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var tmp3_require = $this.tfp_1;
          var tmp4_require = hasComma;
          var tmp5_require = tmp3_require.zfp_1;
          if (!tmp4_require) {
            var tmp$ret$1;
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            tmp$ret$1 = 'Expected comma after the key-value pair';
            tmp3_require.qft(tmp$ret$1, tmp5_require);
          }
        }
      }
      var tmp0_this = $this;
      tmp0_this.vfp_1 = tmp0_this.vfp_1 + 1 | 0;
      tmp = tmp0_this.vfp_1;
    } else {
      if (hasComma) {
        $this.tfp_1.qft("Expected '}', but had ',' instead");
      }
      Companion_getInstance_0();
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp0_tryCoerceValue = $this.rfp_1;
      var tmp1_tryCoerceValue = descriptor.if7(index);
      var tmp;
      if (!tmp1_tryCoerceValue.zf6()) {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp$ret$0 = $this.tfp_1.ffw(true);
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp1_tryCoerceValue.gf7(), ENUM_getInstance())) {
        var tmp_0;
        if (tmp1_tryCoerceValue.zf6()) {
          var tmp$ret$2;
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          tmp$ret$2 = $this.tfp_1.ffw(false);
          tmp_0 = tmp$ret$2;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        var tmp$ret$3;
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp$ret$3 = $this.tfp_1.gfw($this.xfp_1.ufq_1);
        var tmp0_elvis_lhs = tmp$ret$3;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(tmp1_tryCoerceValue, tmp0_tryCoerceValue, enumValue);
        Companion_getInstance_0();
        if (enumIndex === -3) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          $this.tfp_1.sfu();
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.tfp_1.efw();
    while ($this.tfp_1.rfu()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.tfp_1.dfw(get_COLON());
      var index = getJsonNameIndex(descriptor, $this.rfp_1, key);
      var tmp;
      Companion_getInstance_0();
      if (!(index === -3)) {
        var tmp_0;
        if ($this.xfp_1.zfq_1 ? coerceInputValue($this, descriptor, index) : false) {
          hasComma = $this.tfp_1.efw();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.yfp_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.vfe(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, key);
      }
    }
    if (hasComma) {
      $this.tfp_1.qft('Unexpected trailing comma');
    }
    var tmp1_safe_receiver = $this.yfp_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.wfe();
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      Companion_getInstance_0();
      tmp_1 = -1;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    return tmp_1;
  }
  function handleUnknown($this, key) {
    if ($this.xfp_1.tfq_1 ? true : trySkip($this.wfp_1, $this, key)) {
      $this.tfp_1.ifw($this.xfp_1.ufq_1);
    } else {
      $this.tfp_1.hfw(key);
    }
    return $this.tfp_1.efw();
  }
  function decodeListIndex($this) {
    var hasComma = $this.tfp_1.efw();
    var tmp;
    if ($this.tfp_1.rfu()) {
      if (!($this.vfp_1 === -1) ? !hasComma : false) {
        $this.tfp_1.qft('Expected end of the array or comma');
      }
      var tmp0_this = $this;
      tmp0_this.vfp_1 = tmp0_this.vfp_1 + 1 | 0;
      tmp = tmp0_this.vfp_1;
    } else {
      if (hasComma) {
        $this.tfp_1.qft('Unexpected trailing comma');
      }
      Companion_getInstance_0();
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.xfp_1.ufq_1) {
      tmp = $this.tfp_1.kfw();
    } else {
      tmp = $this.tfp_1.jfw();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.rfp_1 = json;
    this.sfp_1 = mode;
    this.tfp_1 = lexer;
    this.ufp_1 = this.rfp_1.of9();
    this.vfp_1 = -1;
    this.wfp_1 = discriminatorHolder;
    this.xfp_1 = this.rfp_1.lfp_1;
    this.yfp_1 = this.xfp_1.xfq_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).ffr = function () {
    return this.rfp_1;
  };
  protoOf(StreamingJsonDecoder).of9 = function () {
    return this.ufp_1;
  };
  protoOf(StreamingJsonDecoder).gfr = function () {
    return (new JsonTreeReader(this.rfp_1.lfp_1, this.tfp_1)).m3j();
  };
  protoOf(StreamingJsonDecoder).yf8 = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.rfp_1.lfp_1.afr_1;
      }
      if (tmp) {
        return deserializer.sf5(this);
      }
      var discriminator = classDiscriminator(deserializer.qf5(), this.rfp_1);
      var type = this.tfp_1.lfw(discriminator, this.xfp_1.ufq_1);
      var actualSerializer = null;
      if (!(type == null)) {
        actualSerializer = deserializer.gf6(this, type);
      }
      if (actualSerializer == null) {
        return decodeSerializableValuePolymorphic(this, isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE());
      }
      this.wfp_1 = new DiscriminatorHolder(discriminator);
      var tmp_0 = actualSerializer.sf5(this);
      var result = isObject(tmp_0) ? tmp_0 : THROW_CCE();
      return result;
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.sf6_1, plus(e.message, ' at path: ') + this.tfp_1.afq_1.dfu(), e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(StreamingJsonDecoder).zf8 = function (descriptor) {
    var newMode = switchMode(this.rfp_1, descriptor);
    this.tfp_1.afq_1.yft(descriptor);
    this.tfp_1.dfw(newMode.ofw_1);
    checkLeadingComma(this);
    var tmp0_subject = newMode;
    var tmp0 = tmp0_subject.b2_1;
    var tmp;
    switch (tmp0) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.rfp_1, newMode, this.tfp_1, descriptor, this.wfp_1);
        break;
      default:
        var tmp_0;
        if (this.sfp_1.equals(newMode) ? this.rfp_1.lfp_1.xfq_1 : false) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.rfp_1, newMode, this.tfp_1, descriptor, this.wfp_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).af9 = function (descriptor) {
    if (this.rfp_1.lfp_1.tfq_1 ? descriptor.ef7() === 0 : false) {
      skipLeftoverElements(this, descriptor);
    }
    this.tfp_1.dfw(this.sfp_1.pfw_1);
    this.tfp_1.afq_1.cfu();
  };
  protoOf(StreamingJsonDecoder).kf8 = function () {
    var tmp;
    var tmp0_safe_receiver = this.yfp_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pft_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.tfp_1.qfw();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).lf8 = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).lf9 = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.sfp_1.equals(WriteMode_MAP_getInstance()) ? (index & 1) === 0 : false;
    if (isMapKey) {
      this.tfp_1.afq_1.bfu();
    }
    var value = protoOf(AbstractDecoder).lf9.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.tfp_1.afq_1.afu(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).qf9 = function (descriptor) {
    var tmp0_subject = this.sfp_1;
    var tmp0 = tmp0_subject.b2_1;
    {
      var index;
      switch (tmp0) {
        case 0:
          index = decodeObjectIndex(this, descriptor);
          break;
        case 2:
          index = decodeMapIndex(this);
          break;
        default:
          index = decodeListIndex(this);
          break;
      }
    }
    if (!this.sfp_1.equals(WriteMode_MAP_getInstance())) {
      this.tfp_1.afq_1.zft(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).mf8 = function () {
    var tmp;
    if (this.xfp_1.ufq_1) {
      tmp = this.tfp_1.sfw();
    } else {
      tmp = this.tfp_1.rfw();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).nf8 = function () {
    var value = this.tfp_1.tfw();
    if (!value.equals(toLong_0(value.bn()))) {
      this.tfp_1.qft("Failed to parse byte for input '" + toString(value) + "'");
    }
    return value.bn();
  };
  protoOf(StreamingJsonDecoder).of8 = function () {
    var value = this.tfp_1.tfw();
    if (!value.equals(toLong_0(value.cn()))) {
      this.tfp_1.qft("Failed to parse short for input '" + toString(value) + "'");
    }
    return value.cn();
  };
  protoOf(StreamingJsonDecoder).pf8 = function () {
    var value = this.tfp_1.tfw();
    if (!value.equals(toLong_0(value.t1()))) {
      this.tfp_1.qft("Failed to parse int for input '" + toString(value) + "'");
    }
    return value.t1();
  };
  protoOf(StreamingJsonDecoder).qf8 = function () {
    return this.tfp_1.tfw();
  };
  protoOf(StreamingJsonDecoder).rf8 = function () {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var tmp0_parseString = this.tfp_1;
      var input = tmp0_parseString.tfu();
      try {
        var tmp$ret$3;
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        var tmp$ret$2;
        // Inline function 'kotlin.text.toFloat' call
        var tmp$ret$1;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp0_unsafeCast = toDouble(input);
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp0_unsafeCast;
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;
        tmp$ret$3 = tmp$ret$2;
        tmp$ret$4 = tmp$ret$3;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0_parseString.qft("Failed to parse type 'float' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.rfp_1.lfp_1.cfr_1;
    if (specialFp ? true : isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.tfp_1, result);
  };
  protoOf(StreamingJsonDecoder).sf8 = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var tmp0_parseString = this.tfp_1;
      var input = tmp0_parseString.tfu();
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$0 = toDouble(input);
        tmp$ret$1 = tmp$ret$0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0_parseString.qft("Failed to parse type 'double' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.rfp_1.lfp_1.cfr_1;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.tfp_1, result);
  };
  protoOf(StreamingJsonDecoder).tf8 = function () {
    var string = this.tfp_1.tfu();
    if (!(string.length === 1)) {
      this.tfp_1.qft("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  };
  protoOf(StreamingJsonDecoder).uf8 = function () {
    var tmp;
    if (this.xfp_1.ufq_1) {
      tmp = this.tfp_1.kfw();
    } else {
      tmp = this.tfp_1.sfu();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).wf8 = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.tfp_1, this.rfp_1) : protoOf(AbstractDecoder).wf8.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).vf8 = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.rfp_1, this.uf8(), ' at path ' + this.tfp_1.afq_1.dfu());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.ufw_1 = lexer;
    this.vfw_1 = json.of9();
  }
  protoOf(JsonDecoderForUnsignedTypes).of9 = function () {
    return this.vfw_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).qf9 = function (descriptor) {
    throw IllegalStateException_init_$Create$('unsupported');
  };
  protoOf(JsonDecoderForUnsignedTypes).pf8 = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var tmp0_parseString = this.ufw_1;
      var input = tmp0_parseString.tfu();
      try {
        var tmp$ret$1;
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'kotlin.UInt.toInt' call
        var tmp0_toInt = toUInt(input);
        tmp$ret$0 = _UInt___get_data__impl__f0vqqw(tmp0_toInt);
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0_parseString.qft("Failed to parse type 'UInt' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).qf8 = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var tmp0_parseString = this.ufw_1;
      var input = tmp0_parseString.tfu();
      try {
        var tmp$ret$1;
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'kotlin.ULong.toLong' call
        var tmp0_toLong = toULong(input);
        tmp$ret$0 = _ULong___get_data__impl__fggpzb(tmp0_toLong);
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0_parseString.qft("Failed to parse type 'ULong' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).nf8 = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var tmp0_parseString = this.ufw_1;
      var input = tmp0_parseString.tfu();
      try {
        var tmp$ret$1;
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'kotlin.UByte.toByte' call
        var tmp0_toByte = toUByte(input);
        tmp$ret$0 = _UByte___get_data__impl__jof9qr(tmp0_toByte);
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0_parseString.qft("Failed to parse type 'UByte' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).of8 = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var tmp0_parseString = this.ufw_1;
      var input = tmp0_parseString.tfu();
      try {
        var tmp$ret$1;
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        var tmp$ret$0;
        // Inline function 'kotlin.UShort.toShort' call
        var tmp0_toShort = toUShort(input);
        tmp$ret$0 = _UShort___get_data__impl__g0245(tmp0_toShort);
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          tmp0_parseString.qft("Failed to parse type 'UShort' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, descriptor) {
    $this.efu_1.ofs();
    $this.dfa(ensureNotNull($this.lfu_1));
    $this.efu_1.qfs(get_COLON());
    $this.efu_1.pfs();
    $this.dfa(descriptor.qf6());
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.efu_1 = composer;
    this.ffu_1 = json;
    this.gfu_1 = mode;
    this.hfu_1 = modeReuseCache;
    this.ifu_1 = this.ffu_1.of9();
    this.jfu_1 = this.ffu_1.lfp_1;
    this.kfu_1 = false;
    this.lfu_1 = null;
    var i = this.gfu_1.b2_1;
    if (!(this.hfu_1 == null)) {
      if (!(this.hfu_1[i] === null) ? true : !(this.hfu_1[i] === this)) {
        this.hfu_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).ffr = function () {
    return this.ffu_1;
  };
  protoOf(StreamingJsonEncoder).of9 = function () {
    return this.ifu_1;
  };
  protoOf(StreamingJsonEncoder).wfa = function (descriptor, index) {
    return this.jfu_1.sfq_1;
  };
  protoOf(StreamingJsonEncoder).rfa = function (serializer, value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      var tmp;
      if (!(serializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.ffr().lfp_1.afr_1;
      }
      if (tmp) {
        serializer.rf5(this, value);
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      var baseClassDiscriminator = classDiscriminator(serializer.qf5(), this.ffr());
      var actualSerializer = findPolymorphicSerializer(casted, this, isObject(value) ? value : THROW_CCE());
      validateIfSealed$accessor$1ad0flx(casted, actualSerializer, baseClassDiscriminator);
      checkKind(actualSerializer.qf5().gf7());
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
      this.lfu_1 = baseClassDiscriminator;
      actualSerializer.rf5(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).zf8 = function (descriptor) {
    var newMode = switchMode(this.ffu_1, descriptor);
    if (!equals(new Char(newMode.ofw_1), new Char(get_INVALID()))) {
      this.efu_1.qfs(newMode.ofw_1);
      this.efu_1.mfs();
    }
    if (!(this.lfu_1 == null)) {
      encodeTypeInfo(this, descriptor);
      this.lfu_1 = null;
    }
    if (this.gfu_1.equals(newMode)) {
      return this;
    }
    var tmp0_safe_receiver = this.hfu_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver[newMode.b2_1];
    return tmp1_elvis_lhs == null ? new StreamingJsonEncoder(this.efu_1, this.ffu_1, newMode, this.hfu_1) : tmp1_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).af9 = function (descriptor) {
    if (!equals(new Char(this.gfu_1.pfw_1), new Char(get_INVALID()))) {
      this.efu_1.nfs();
      this.efu_1.ofs();
      this.efu_1.qfs(this.gfu_1.pfw_1);
    }
  };
  protoOf(StreamingJsonEncoder).sf9 = function (descriptor, index) {
    var tmp0_subject = this.gfu_1;
    var tmp0 = tmp0_subject.b2_1;
    switch (tmp0) {
      case 1:
        if (!this.efu_1.lfs_1) {
          this.efu_1.qfs(get_COMMA());
        }

        this.efu_1.ofs();
        ;
        break;
      case 2:
        if (!this.efu_1.lfs_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.efu_1.qfs(get_COMMA());
            this.efu_1.ofs();
            tmp_0 = true;
          } else {
            this.efu_1.qfs(get_COLON());
            this.efu_1.pfs();
            tmp_0 = false;
          }
          tmp.kfu_1 = tmp_0;
        } else {
          this.kfu_1 = true;
          this.efu_1.ofs();
        }

        break;
      case 3:
        if (index === 0)
          this.kfu_1 = true;
        if (index === 1) {
          this.efu_1.qfs(get_COMMA());
          this.efu_1.pfs();
          this.kfu_1 = false;
        }

        break;
      default:
        if (!this.efu_1.lfs_1) {
          this.efu_1.qfs(get_COMMA());
        }

        this.efu_1.ofs();
        this.dfa(getJsonElementName(descriptor, this.ffu_1, index));
        this.efu_1.qfs(get_COLON());
        this.efu_1.pfs();
        ;
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).sfa = function (descriptor, index, serializer, value) {
    if (!(value == null) ? true : this.jfu_1.xfq_1) {
      protoOf(AbstractEncoder).sfa.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).ffa = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      var tmp$ret$0;
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.efu_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.efu_1;
      } else {
        tmp_0 = new ComposerForUnsignedNumbers(this.efu_1.kfs_1, this.kfu_1);
      }
      tmp$ret$0 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$0, this.ffu_1, this.gfu_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      var tmp$ret$1;
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.efu_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.efu_1;
      } else {
        tmp_2 = new ComposerForUnquotedLiterals(this.efu_1.kfs_1, this.kfu_1);
      }
      tmp$ret$1 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.ffu_1, this.gfu_1, null);
    } else {
      tmp = protoOf(AbstractEncoder).ffa.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).uf9 = function () {
    this.efu_1.sfs(get_NULL());
  };
  protoOf(StreamingJsonEncoder).vf9 = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.bft(value);
    }
  };
  protoOf(StreamingJsonEncoder).wf9 = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.wfs(value);
    }
  };
  protoOf(StreamingJsonEncoder).xf9 = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.yfs(value);
    }
  };
  protoOf(StreamingJsonEncoder).yf9 = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.zfs(value);
    }
  };
  protoOf(StreamingJsonEncoder).zf9 = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.aft(value);
    }
  };
  protoOf(StreamingJsonEncoder).afa = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.ufs(value);
    }
    if (!this.jfu_1.cfr_1 ? !isFinite(value) : false) {
      throw InvalidFloatingPointEncoded(value, toString(this.efu_1.kfs_1));
    }
  };
  protoOf(StreamingJsonEncoder).bfa = function (value) {
    if (this.kfu_1) {
      this.dfa(value.toString());
    } else {
      this.efu_1.vfs(value);
    }
    if (!this.jfu_1.cfr_1 ? !isFinite_0(value) : false) {
      throw InvalidFloatingPointEncoded(value, toString(this.efu_1.kfs_1));
    }
  };
  protoOf(StreamingJsonEncoder).cfa = function (value) {
    this.dfa(toString_0(value));
  };
  protoOf(StreamingJsonEncoder).dfa = function (value) {
    return this.efu_1.cft(value);
  };
  protoOf(StreamingJsonEncoder).efa = function (enumDescriptor, index) {
    this.dfa(enumDescriptor.kf7(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.ff7() ? get_unsignedNumberDescriptors().q(_this__u8e3s4) : false;
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.ff7() ? equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor()) : false;
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    } else {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_1()).qf5(), serializer_0(Companion_getInstance()).qf5(), serializer_2(Companion_getInstance_2()).qf5(), serializer_3(Companion_getInstance_3()).qf5()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      var tmp$ret$0;
      // Inline function 'kotlin.code' call
      tmp$ret$0 = 48;
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      var tmp$ret$1;
      // Inline function 'kotlin.code' call
      tmp$ret$1 = 97;
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.ib(get_STRING());
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$0;
        // Inline function 'kotlin.code' call
        var tmp0__get_code__88qj9g = charSequenceGet(value, i);
        tmp$ret$0 = Char__toInt_impl_vasixd(tmp0__get_code__88qj9g);
        var c = tmp$ret$0;
        if (c < get_ESCAPE_STRINGS().length ? !(get_ESCAPE_STRINGS()[c] == null) : false) {
          _this__u8e3s4.ik(value, lastPos, i);
          _this__u8e3s4.bc(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0)) {
      _this__u8e3s4.ik(value, lastPos, value.length);
    } else {
      _this__u8e3s4.bc(value);
    }
    _this__u8e3s4.ib(get_STRING());
  }
  function toBooleanStrictOrNull(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (properties_initialized_StringOps_kt_wzaea7) {
    } else {
      properties_initialized_StringOps_kt_wzaea7 = true;
      var tmp$ret$7;
      // Inline function 'kotlin.apply' call
      var tmp$ret$0;
      // Inline function 'kotlin.arrayOfNulls' call
      tmp$ret$0 = fillArrayVal(Array(93), null);
      var tmp0_apply = tmp$ret$0;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          tmp0_apply[c] = '\\u' + new Char(c1) + new Char(c2) + new Char(c3) + new Char(c4);
        }
         while (inductionVariable <= 31);
      var tmp$ret$1;
      // Inline function 'kotlin.code' call
      tmp$ret$1 = 34;
      tmp0_apply[tmp$ret$1] = '\\"';
      var tmp$ret$2;
      // Inline function 'kotlin.code' call
      tmp$ret$2 = 92;
      tmp0_apply[tmp$ret$2] = '\\\\';
      var tmp$ret$3;
      // Inline function 'kotlin.code' call
      tmp$ret$3 = 9;
      tmp0_apply[tmp$ret$3] = '\\t';
      var tmp$ret$4;
      // Inline function 'kotlin.code' call
      tmp$ret$4 = 8;
      tmp0_apply[tmp$ret$4] = '\\b';
      var tmp$ret$5;
      // Inline function 'kotlin.code' call
      tmp$ret$5 = 10;
      tmp0_apply[tmp$ret$5] = '\\n';
      var tmp$ret$6;
      // Inline function 'kotlin.code' call
      tmp$ret$6 = 13;
      tmp0_apply[tmp$ret$6] = '\\r';
      tmp0_apply[12] = '\\f';
      tmp$ret$7 = tmp0_apply;
      ESCAPE_STRINGS = tmp$ret$7;
      var tmp$ret$13;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_0 = new Int8Array(93);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          tmp0_apply_0[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      var tmp$ret$0_0;
      // Inline function 'kotlin.code' call
      tmp$ret$0_0 = 34;
      var tmp = tmp$ret$0_0;
      var tmp$ret$1_0;
      // Inline function 'kotlin.code' call
      tmp$ret$1_0 = 34;
      tmp0_apply_0[tmp] = toByte(tmp$ret$1_0);
      var tmp$ret$2_0;
      // Inline function 'kotlin.code' call
      tmp$ret$2_0 = 92;
      var tmp_0 = tmp$ret$2_0;
      var tmp$ret$3_0;
      // Inline function 'kotlin.code' call
      tmp$ret$3_0 = 92;
      tmp0_apply_0[tmp_0] = toByte(tmp$ret$3_0);
      var tmp$ret$4_0;
      // Inline function 'kotlin.code' call
      tmp$ret$4_0 = 9;
      var tmp_1 = tmp$ret$4_0;
      var tmp$ret$5_0;
      // Inline function 'kotlin.code' call
      tmp$ret$5_0 = 116;
      tmp0_apply_0[tmp_1] = toByte(tmp$ret$5_0);
      var tmp$ret$6_0;
      // Inline function 'kotlin.code' call
      tmp$ret$6_0 = 8;
      var tmp_2 = tmp$ret$6_0;
      var tmp$ret$7_0;
      // Inline function 'kotlin.code' call
      tmp$ret$7_0 = 98;
      tmp0_apply_0[tmp_2] = toByte(tmp$ret$7_0);
      var tmp$ret$8;
      // Inline function 'kotlin.code' call
      tmp$ret$8 = 10;
      var tmp_3 = tmp$ret$8;
      var tmp$ret$9;
      // Inline function 'kotlin.code' call
      tmp$ret$9 = 110;
      tmp0_apply_0[tmp_3] = toByte(tmp$ret$9);
      var tmp$ret$10;
      // Inline function 'kotlin.code' call
      tmp$ret$10 = 13;
      var tmp_4 = tmp$ret$10;
      var tmp$ret$11;
      // Inline function 'kotlin.code' call
      tmp$ret$11 = 114;
      tmp0_apply_0[tmp_4] = toByte(tmp$ret$11);
      var tmp$ret$12;
      // Inline function 'kotlin.code' call
      tmp$ret$12 = 102;
      tmp0_apply_0[12] = toByte(tmp$ret$12);
      tmp$ret$13 = tmp0_apply_0;
      ESCAPE_MARKERS = tmp$ret$13;
    }
  }
  function currentObject($this) {
    var tmp0_safe_receiver = $this.ufm();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp$ret$0 = $this.bfx(tmp0_safe_receiver);
      tmp$ret$1 = tmp$ret$0;
      tmp = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? $this.f1() : tmp1_elvis_lhs;
  }
  function unparsedPrimitive($this, primitive) {
    throw JsonDecodingException_0(-1, "Failed to parse '" + primitive + "'", toString(currentObject($this)));
  }
  function asLiteral(_this__u8e3s4, $this, type) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonLiteral ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_1(-1, "Unexpected 'null' when " + type + ' was expected');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function AbstractJsonTreeDecoder(json, value) {
    NamedValueDecoder.call(this);
    this.yfw_1 = json;
    this.zfw_1 = value;
    this.afx_1 = this.ffr().lfp_1;
  }
  protoOf(AbstractJsonTreeDecoder).ffr = function () {
    return this.yfw_1;
  };
  protoOf(AbstractJsonTreeDecoder).f1 = function () {
    return this.zfw_1;
  };
  protoOf(AbstractJsonTreeDecoder).of9 = function () {
    return this.ffr().of9();
  };
  protoOf(AbstractJsonTreeDecoder).gfr = function () {
    return currentObject(this);
  };
  protoOf(AbstractJsonTreeDecoder).yf8 = function (deserializer) {
    return decodeSerializableValuePolymorphic(this, deserializer);
  };
  protoOf(AbstractJsonTreeDecoder).vfm = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).zf8 = function (descriptor) {
    var currentObject_0 = currentObject(this);
    var tmp0_subject = descriptor.gf7();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.ffr();
      var tmp$ret$0;
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      if (!(currentObject_0 instanceof JsonArray)) {
        throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonArray) + ' as the serialized body of ' + descriptor.qf6() + ', but had ' + getKClassFromExpression(currentObject_0));
      }
      tmp$ret$0 = currentObject_0;
      tmp = new JsonTreeListDecoder(tmp_1, tmp$ret$0);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        var tmp$ret$5;
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var tmp0_selectMapMode = this.ffr();
        var keyDescriptor = carrierDescriptor(descriptor.if7(0), tmp0_selectMapMode.of9());
        var keyKind = keyDescriptor.gf7();
        var tmp_2;
        var tmp_3;
        if (keyKind instanceof PrimitiveKind) {
          tmp_3 = true;
        } else {
          tmp_3 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_3) {
          var tmp$ret$2;
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_4 = this.ffr();
          var tmp$ret$1;
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          if (!(currentObject_0 instanceof JsonObject)) {
            throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.qf6() + ', but had ' + getKClassFromExpression(currentObject_0));
          }
          tmp$ret$1 = currentObject_0;
          tmp$ret$2 = new JsonTreeMapDecoder(tmp_4, tmp$ret$1);
          tmp_2 = tmp$ret$2;
        } else {
          if (tmp0_selectMapMode.lfp_1.vfq_1) {
            var tmp$ret$4;
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_5 = this.ffr();
            var tmp$ret$3;
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            if (!(currentObject_0 instanceof JsonArray)) {
              throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonArray) + ' as the serialized body of ' + descriptor.qf6() + ', but had ' + getKClassFromExpression(currentObject_0));
            }
            tmp$ret$3 = currentObject_0;
            tmp$ret$4 = new JsonTreeListDecoder(tmp_5, tmp$ret$3);
            tmp_2 = tmp$ret$4;
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp$ret$5 = tmp_2;
        tmp = tmp$ret$5;
      } else {
        var tmp_6 = this.ffr();
        var tmp$ret$6;
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        if (!(currentObject_0 instanceof JsonObject)) {
          throw JsonDecodingException_1(-1, 'Expected ' + getKClass(JsonObject) + ' as the serialized body of ' + descriptor.qf6() + ', but had ' + getKClassFromExpression(currentObject_0));
        }
        tmp$ret$6 = currentObject_0;
        tmp = new JsonTreeDecoder(tmp_6, tmp$ret$6);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).af9 = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).kf8 = function () {
    var tmp = currentObject(this);
    return !(tmp instanceof JsonNull);
  };
  protoOf(AbstractJsonTreeDecoder).cfx = function (tag) {
    var currentElement = this.bfx(tag);
    var tmp0_elvis_lhs = currentElement instanceof JsonPrimitive ? currentElement : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw JsonDecodingException_0(-1, 'Expected JsonPrimitive at ' + tag + ', found ' + currentElement, toString(currentObject(this)));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).dfx = function (tag, enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.ffr(), this.cfx(tag).mfr());
  };
  protoOf(AbstractJsonTreeDecoder).hfn = function (tag, enumDescriptor) {
    return this.dfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).efx = function (tag) {
    return !(this.bfx(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).xfm = function (tag) {
    return this.efx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).ffx = function (tag) {
    var value = this.cfx(tag);
    if (!this.ffr().lfp_1.ufq_1) {
      var literal = asLiteral(value, this, 'boolean');
      if (literal.nfr_1)
        throw JsonDecodingException_0(-1, "Boolean literal for key '" + tag + "' should be unquoted.\n" + get_lenientHint(), toString(currentObject(this)));
    }
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedBoolean.<anonymous>' call
        var tmp0_elvis_lhs = get_booleanOrNull(value);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException_init_$Create$_0();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$0 = tmp;
        var tmp0_elvis_lhs_0 = tmp$ret$0;
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          unparsedPrimitive(this, 'boolean');
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'boolean');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).yfm = function (tag) {
    return this.ffx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).gfx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(tmp0_primitive);
        var tmp;
        var containsLower = ByteCompanionObject_getInstance().MIN_VALUE;
        if (result <= ByteCompanionObject_getInstance().MAX_VALUE ? containsLower <= result : false) {
          tmp = toByte(result);
        } else {
          tmp = null;
        }
        tmp$ret$0 = tmp;
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'byte');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'byte');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).zfm = function (tag) {
    return this.gfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).hfx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(tmp0_primitive);
        var tmp;
        var containsLower = ShortCompanionObject_getInstance().MIN_VALUE;
        if (result <= ShortCompanionObject_getInstance().MAX_VALUE ? containsLower <= result : false) {
          tmp = toShort(result);
        } else {
          tmp = null;
        }
        tmp$ret$0 = tmp;
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'short');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp_0;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'short');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).afn = function (tag) {
    return this.hfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).ifx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        tmp$ret$0 = get_int(tmp0_primitive);
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'int');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'int');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).bfn = function (tag) {
    return this.ifx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).jfx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        tmp$ret$0 = get_long(tmp0_primitive);
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'long');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'long');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).cfn = function (tag) {
    return this.jfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).kfx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        tmp$ret$0 = get_float(tmp0_primitive);
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'float');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'float');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.ffr().lfp_1.cfr_1;
    if (specialFp ? true : isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).dfn = function (tag) {
    return this.kfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).lfx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        tmp$ret$0 = get_double(tmp0_primitive);
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, 'double');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'double');
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.ffr().lfp_1.cfr_1;
    if (specialFp ? true : isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(currentObject(this)));
  };
  protoOf(AbstractJsonTreeDecoder).efn = function (tag) {
    return this.lfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).mfx = function (tag) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.primitive' call
      var tmp0_primitive = this.cfx(tag);
      try {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        tmp$ret$0 = single(tmp0_primitive.mfr());
        var tmp0_elvis_lhs = tmp$ret$0;
        var tmp;
        var tmp_0 = tmp0_elvis_lhs;
        if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
          unparsedPrimitive(this, 'char');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        tmp$ret$1 = tmp;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, 'char');
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$1;
  };
  protoOf(AbstractJsonTreeDecoder).ffn = function (tag) {
    return this.mfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).nfx = function (tag) {
    var value = this.cfx(tag);
    if (!this.ffr().lfp_1.ufq_1) {
      var literal = asLiteral(value, this, 'string');
      if (!literal.nfr_1)
        throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted.\n" + get_lenientHint(), toString(currentObject(this)));
    }
    if (value instanceof JsonNull)
      throw JsonDecodingException_0(-1, "Unexpected 'null' value instead of string literal", toString(currentObject(this)));
    return value.mfr();
  };
  protoOf(AbstractJsonTreeDecoder).gfn = function (tag) {
    return this.nfx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).ofx = function (tag, inlineDescriptor) {
    return get_isUnsignedNumber(inlineDescriptor) ? new JsonDecoderForUnsignedTypes(new StringJsonLexer(this.cfx(tag).mfr()), this.ffr()) : protoOf(NamedValueDecoder).ifn.call(this, tag, inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).ifn = function (tag, inlineDescriptor) {
    return this.ofx((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).wf8 = function (descriptor) {
    return !(this.ufm() == null) ? protoOf(NamedValueDecoder).wf8.call(this, descriptor) : (new JsonPrimitiveDecoder(this.ffr(), this.f1())).wf8(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var tmp0_tryCoerceValue = $this.ffr();
      var tmp1_tryCoerceValue = descriptor.if7(index);
      var tmp;
      if (!tmp1_tryCoerceValue.zf6()) {
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_0 = $this.bfx(tag);
        tmp$ret$0 = tmp_0 instanceof JsonNull;
        tmp = tmp$ret$0;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(tmp1_tryCoerceValue.gf7(), ENUM_getInstance())) {
        var tmp_1;
        if (tmp1_tryCoerceValue.zf6()) {
          var tmp$ret$2;
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
          var tmp_2 = $this.bfx(tag);
          tmp$ret$2 = tmp_2 instanceof JsonNull;
          tmp_1 = tmp$ret$2;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        var tmp$ret$3;
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_3 = $this.bfx(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        tmp$ret$3 = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp0_elvis_lhs = tmp$ret$3;
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(tmp1_tryCoerceValue, tmp0_tryCoerceValue, enumValue);
        Companion_getInstance_0();
        if (enumIndex === -3) {
          var tmp$ret$4;
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
          tmp$ret$4 = Unit_getInstance();
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.yfx_1 = (!$this.ffr().lfp_1.xfq_1 ? !descriptor.lf7(index) : false) ? descriptor.if7(index).zf6() : false;
    return $this.yfx_1;
  }
  function JsonTreeDecoder(json, value, polyDiscriminator, polyDescriptor) {
    polyDiscriminator = polyDiscriminator === VOID ? null : polyDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value);
    this.ufx_1 = value;
    this.vfx_1 = polyDiscriminator;
    this.wfx_1 = polyDescriptor;
    this.xfx_1 = 0;
    this.yfx_1 = false;
  }
  protoOf(JsonTreeDecoder).f1 = function () {
    return this.ufx_1;
  };
  protoOf(JsonTreeDecoder).qf9 = function (descriptor) {
    while (this.xfx_1 < descriptor.ef7()) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.xfx_1;
      tmp0_this.xfx_1 = tmp1 + 1 | 0;
      var name = this.pfm(descriptor, tmp1);
      var index = this.xfx_1 - 1 | 0;
      this.yfx_1 = false;
      var tmp;
      var tmp_0;
      var tmp$ret$1;
      // Inline function 'kotlin.collections.contains' call
      var tmp0_contains = this.f1();
      var tmp$ret$0;
      // Inline function 'kotlin.collections.containsKey' call
      tmp$ret$0 = (isInterface(tmp0_contains, Map) ? tmp0_contains : THROW_CCE()).b3(name);
      tmp$ret$1 = tmp$ret$0;
      if (tmp$ret$1) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.afx_1.zfq_1 ? true : !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    Companion_getInstance_0();
    return -1;
  };
  protoOf(JsonTreeDecoder).kf8 = function () {
    return !this.yfx_1 ? protoOf(AbstractJsonTreeDecoder).kf8.call(this) : false;
  };
  protoOf(JsonTreeDecoder).qfm = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.ffr());
    var baseName = descriptor.kf7(index);
    if (strategy == null) {
      if (!this.afx_1.dfr_1)
        return baseName;
      if (this.f1().i3().q(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.ffr(), descriptor);
    var tmp$ret$2;
    // Inline function 'kotlin.collections.find' call
    var tmp0_find = this.f1().i3();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = tmp0_find.h();
      while (tmp0_iterator.j()) {
        var element = tmp0_iterator.k();
        var tmp$ret$0;
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        tmp$ret$0 = deserializationNamesMap_0.h3(element) === index;
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp$ret$2 = tmp$ret$1;
    var tmp0_safe_receiver = tmp$ret$2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp$ret$3;
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var tmp1_safe_receiver = strategy;
    var fallbackName = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.uft(descriptor, index, baseName);
    var tmp2_elvis_lhs = fallbackName;
    return tmp2_elvis_lhs == null ? baseName : tmp2_elvis_lhs;
  };
  protoOf(JsonTreeDecoder).bfx = function (tag) {
    return getValue(this.f1(), tag);
  };
  protoOf(JsonTreeDecoder).zf8 = function (descriptor) {
    if (descriptor === this.wfx_1)
      return this;
    return protoOf(AbstractJsonTreeDecoder).zf8.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).af9 = function (descriptor) {
    var tmp;
    if (this.afx_1.tfq_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.gf7();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_getInstance();
    var strategy = namingStrategy(descriptor, this.ffr());
    var tmp_1;
    if (strategy == null ? !this.afx_1.dfr_1 : false) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.ffr(), descriptor).i3();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      var tmp$ret$0;
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_safe_receiver = get_schemaCache(this.ffr()).bfw(descriptor, get_JsonDeserializationNamesKey());
      var tmp0_orEmpty = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i3();
      var tmp0_elvis_lhs = tmp0_orEmpty;
      tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var tmp1_iterator = this.f1().i3().h();
    while (tmp1_iterator.j()) {
      var key = tmp1_iterator.k();
      if (!names.q(key) ? !(key === this.vfx_1) : false) {
        throw UnknownKeyException(key, this.f1().toString());
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.efy_1 = value;
    this.ffy_1 = this.efy_1.l();
    this.gfy_1 = -1;
  }
  protoOf(JsonTreeListDecoder).f1 = function () {
    return this.efy_1;
  };
  protoOf(JsonTreeListDecoder).qfm = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).bfx = function (tag) {
    return this.efy_1.n(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).qf9 = function (descriptor) {
    while (this.gfy_1 < (this.ffy_1 - 1 | 0)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.gfy_1;
      tmp0_this.gfy_1 = tmp1 + 1 | 0;
      return this.gfy_1;
    }
    Companion_getInstance_0();
    return -1;
  };
  function JsonPrimitiveDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.mfy_1 = value;
    this.jfn(get_PRIMITIVE_TAG());
  }
  protoOf(JsonPrimitiveDecoder).f1 = function () {
    return this.mfy_1;
  };
  protoOf(JsonPrimitiveDecoder).qf9 = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).bfx = function (tag) {
    // Inline function 'kotlin.require' call
    var tmp0_require = tag === get_PRIMITIVE_TAG();
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp0_require) {
      var tmp$ret$0;
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      tmp$ret$0 = "This input can only handle primitives with '" + get_PRIMITIVE_TAG() + "' tag";
      var message = tmp$ret$0;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.mfy_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.xfy_1 = value;
    this.yfy_1 = toList(this.xfy_1.i3());
    this.zfy_1 = imul(this.yfy_1.l(), 2);
    this.afz_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).f1 = function () {
    return this.xfy_1;
  };
  protoOf(JsonTreeMapDecoder).qfm = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.yfy_1.n(i);
  };
  protoOf(JsonTreeMapDecoder).qf9 = function (descriptor) {
    while (this.afz_1 < (this.zfy_1 - 1 | 0)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.afz_1;
      tmp0_this.afz_1 = tmp1 + 1 | 0;
      return this.afz_1;
    }
    Companion_getInstance_0();
    return -1;
  };
  protoOf(JsonTreeMapDecoder).bfx = function (tag) {
    return (this.afz_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.xfy_1, tag);
  };
  protoOf(JsonTreeMapDecoder).af9 = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.qf5())).yf8(deserializer);
  }
  function get_PRIMITIVE_TAG() {
    return PRIMITIVE_TAG;
  }
  var PRIMITIVE_TAG;
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_getInstance();
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, get_BEGIN_OBJ(), get_END_OBJ());
    WriteMode_LIST_instance = new WriteMode('LIST', 1, get_BEGIN_LIST(), get_END_LIST());
    WriteMode_MAP_instance = new WriteMode('MAP', 2, get_BEGIN_OBJ(), get_END_OBJ());
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, get_BEGIN_LIST(), get_END_LIST());
  }
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.ofw_1 = begin;
    this.pfw_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.gf7();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          var tmp$ret$2;
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.if7(0), _this__u8e3s4.of9());
          var keyKind = keyDescriptor.gf7();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            var tmp$ret$0;
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp$ret$0 = WriteMode_MAP_getInstance();
            tmp_0 = tmp$ret$0;
          } else {
            if (_this__u8e3s4.lfp_1.vfq_1) {
              var tmp$ret$1;
              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
              tmp$ret$1 = WriteMode_LIST_getInstance();
              tmp_0 = tmp$ret$1;
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp$ret$2 = tmp_0;
          tmp = tmp$ret$2;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.gf7(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.ff7()) {
      tmp = carrierDescriptor(_this__u8e3s4.if7(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.bfz(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.bfz(lastPosition, currentPosition);
    var result = $this.cfq_1.toString();
    $this.cfq_1.jk(0);
    return result;
  }
  function takePeeked($this) {
    var tmp$ret$0;
    // Inline function 'kotlin.also' call
    var tmp0_also = ensureNotNull($this.bfq_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
    $this.bfq_1 = null;
    tmp$ret$0 = tmp0_also;
    return tmp$ret$0;
  }
  function wasUnquotedString($this) {
    return !equals(new Char(charSequenceGet($this.cfz(), $this.zfp_1 - 1 | 0)), new Char(_Char___init__impl__6a9atx(34)));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.dfz(currentPosition);
    if (currentPosition === -1) {
      $this.qft('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.cfz();
    var tmp0 = currentPosition;
    currentPosition = tmp0 + 1 | 0;
    var currentChar = charSequenceGet(tmp, tmp0);
    if (equals(new Char(currentChar), new Char(_Char___init__impl__6a9atx(117)))) {
      return appendHex($this, $this.cfz(), currentPosition);
    }
    var tmp$ret$0;
    // Inline function 'kotlin.code' call
    tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (equals(new Char(c), new Char(_Char___init__impl__6a9atx(0)))) {
      $this.qft("Invalid escaped char '" + new Char(currentChar) + "'");
    }
    $this.cfq_1.ib(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.zfp_1 = startPos;
      $this.efz();
      if (($this.zfp_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.qft('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.zfp_1);
    }
    $this.cfq_1.ib(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      var tmp$ret$0;
      // Inline function 'kotlin.code' call
      tmp$ret$0 = Char__toInt_impl_vasixd(character);
      var tmp_0 = tmp$ret$0;
      var tmp$ret$1;
      // Inline function 'kotlin.code' call
      tmp$ret$1 = 48;
      tmp = tmp_0 - tmp$ret$1 | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      var tmp$ret$2;
      // Inline function 'kotlin.code' call
      tmp$ret$2 = Char__toInt_impl_vasixd(character);
      var tmp_1 = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'kotlin.code' call
      tmp$ret$3 = 97;
      tmp = (tmp_1 - tmp$ret$3 | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      var tmp$ret$4;
      // Inline function 'kotlin.code' call
      tmp$ret$4 = Char__toInt_impl_vasixd(character);
      var tmp_2 = tmp$ret$4;
      var tmp$ret$5;
      // Inline function 'kotlin.code' call
      tmp$ret$5 = 65;
      tmp = (tmp_2 - tmp$ret$5 | 0) + 10 | 0;
    } else {
      $this.qft("Invalid toHexChar char '" + new Char(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean($this, start) {
    var current = $this.dfz(start);
    if (current >= charSequenceLength($this.cfz()) ? true : current === -1) {
      $this.qft('EOF');
    }
    var tmp$ret$0;
    // Inline function 'kotlin.code' call
    var tmp = $this.cfz();
    var tmp0 = current;
    current = tmp0 + 1 | 0;
    var tmp0__get_code__88qj9g = charSequenceGet(tmp, tmp0);
    tmp$ret$0 = Char__toInt_impl_vasixd(tmp0__get_code__88qj9g);
    var tmp1_subject = tmp$ret$0 | 32;
    var tmp_0;
    var tmp$ret$1;
    // Inline function 'kotlin.code' call
    tmp$ret$1 = 116;
    if (tmp1_subject === tmp$ret$1) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      var tmp$ret$2;
      // Inline function 'kotlin.code' call
      tmp$ret$2 = 102;
      if (tmp1_subject === tmp$ret$2) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.qft("Expected valid boolean literal prefix, but had '" + $this.tfu() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.cfz()) - current | 0) < literalSuffix.length) {
      $this.qft('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charSequenceGet(literalSuffix, i);
        var actual = charSequenceGet($this.cfz(), current + i | 0);
        var tmp$ret$0;
        // Inline function 'kotlin.code' call
        tmp$ret$0 = Char__toInt_impl_vasixd(expected);
        var tmp = tmp$ret$0;
        var tmp$ret$1;
        // Inline function 'kotlin.code' call
        tmp$ret$1 = Char__toInt_impl_vasixd(actual);
        if (!(tmp === (tmp$ret$1 | 32))) {
          $this.qft("Expected valid boolean literal prefix, but had '" + $this.tfu() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.zfp_1 = current + literalSuffix.length | 0;
  }
  function AbstractJsonLexer() {
    this.zfp_1 = 0;
    this.afq_1 = new JsonPath();
    this.bfq_1 = null;
    this.cfq_1 = StringBuilder_init_$Create$();
  }
  protoOf(AbstractJsonLexer).efz = function () {
  };
  protoOf(AbstractJsonLexer).ffz = function (c) {
    var tmp0_subject = c;
    return (((equals(new Char(tmp0_subject), new Char(_Char___init__impl__6a9atx(125))) ? true : equals(new Char(tmp0_subject), new Char(_Char___init__impl__6a9atx(93)))) ? true : equals(new Char(tmp0_subject), new Char(_Char___init__impl__6a9atx(58)))) ? true : equals(new Char(tmp0_subject), new Char(_Char___init__impl__6a9atx(44)))) ? false : true;
  };
  protoOf(AbstractJsonLexer).dfq = function () {
    var nextToken = this.ufu();
    if (!(nextToken === 10)) {
      this.qft('Expected EOF after parsing, but had ' + new Char(charSequenceGet(this.cfz(), this.zfp_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).pfu = function (expected) {
    var token = this.ufu();
    if (!(token === expected)) {
      this.gfz(expected);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).dfw = function (expected) {
    this.efz();
    var source = this.cfz();
    var cpos = this.zfp_1;
    $l$loop_0: while (true) {
      cpos = this.dfz(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var tmp0 = cpos;
      cpos = tmp0 + 1 | 0;
      var c = charSequenceGet(source, tmp0);
      if (((equals(new Char(c), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(10)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(9))))
        continue $l$loop_0;
      this.zfp_1 = cpos;
      if (equals(new Char(c), new Char(expected)))
        return Unit_getInstance();
      this.hfz(expected);
    }
    this.zfp_1 = cpos;
    this.hfz(expected);
  };
  protoOf(AbstractJsonLexer).hfz = function (expected) {
    var tmp0_this = this;
    tmp0_this.zfp_1 = tmp0_this.zfp_1 - 1 | 0;
    if ((this.zfp_1 >= 0 ? equals(new Char(expected), new Char(_Char___init__impl__6a9atx(34))) : false) ? this.tfu() === 'null' : false) {
      this.ifz("Expected string literal but 'null' literal was found", this.zfp_1 - 4 | 0, "Use 'coerceInputValues = true' in 'Json {}` builder to coerce nulls to default values.");
    }
    this.gfz(charToTokenClass(expected));
  };
  protoOf(AbstractJsonLexer).gfz = function (expectedToken) {
    var tmp0_subject = expectedToken;
    var expected = tmp0_subject === 1 ? "quotation mark '\"'" : tmp0_subject === 4 ? "comma ','" : tmp0_subject === 5 ? "colon ':'" : tmp0_subject === 6 ? "start of the object '{'" : tmp0_subject === 7 ? "end of the object '}'" : tmp0_subject === 8 ? "start of the array '['" : tmp0_subject === 9 ? "end of the array ']'" : 'valid token';
    var s = (this.zfp_1 === charSequenceLength(this.cfz()) ? true : this.zfp_1 <= 0) ? 'EOF' : toString_0(charSequenceGet(this.cfz(), this.zfp_1 - 1 | 0));
    this.qft('Expected ' + expected + ", but had '" + s + "' instead", this.zfp_1 - 1 | 0);
  };
  protoOf(AbstractJsonLexer).qfu = function () {
    var source = this.cfz();
    var cpos = this.zfp_1;
    $l$loop_0: while (true) {
      cpos = this.dfz(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (((equals(new Char(ch), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(ch), new Char(_Char___init__impl__6a9atx(10)))) ? true : equals(new Char(ch), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(ch), new Char(_Char___init__impl__6a9atx(9)))) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.zfp_1 = cpos;
      return charToTokenClass(ch);
    }
    this.zfp_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).ffw = function (doConsume) {
    var current = this.jfz();
    current = this.dfz(current);
    var len = charSequenceLength(this.cfz()) - current | 0;
    if (len < 4 ? true : current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(new Char(charSequenceGet('null', i)), new Char(charSequenceGet(this.cfz(), current + i | 0))))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 ? charToTokenClass(charSequenceGet(this.cfz(), current + 4 | 0)) === 0 : false)
      return false;
    if (doConsume) {
      this.zfp_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).qfw = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.ffw(doConsume) : $super.ffw.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).jfz = function () {
    var current = this.zfp_1;
    $l$loop_0: while (true) {
      current = this.dfz(current);
      if (current === -1)
        break $l$loop_0;
      var c = charSequenceGet(this.cfz(), current);
      if (((equals(new Char(c), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(10)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(9)))) {
        current = current + 1 | 0;
      } else {
        break $l$loop_0;
      }
    }
    this.zfp_1 = current;
    return current;
  };
  protoOf(AbstractJsonLexer).gfw = function (isLenient) {
    var token = this.qfu();
    var tmp;
    if (isLenient) {
      if (!(token === 1) ? !(token === 0) : false)
        return null;
      tmp = this.tfu();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.sfu();
    }
    var string = tmp;
    this.bfq_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).b2s = function (startPos, endPos) {
    var tmp$ret$0;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = this.cfz();
    tmp$ret$0 = toString(charSequenceSubSequence(tmp0_substring, startPos, endPos));
    return tmp$ret$0;
  };
  protoOf(AbstractJsonLexer).sfu = function () {
    if (!(this.bfq_1 == null)) {
      return takePeeked(this);
    }
    return this.jfw();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!equals(new Char(char), new Char(_Char___init__impl__6a9atx(34)))) {
      if (equals(new Char(char), new Char(_Char___init__impl__6a9atx(92)))) {
        usedAppend = true;
        currentPosition = this.dfz(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.qft('EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.bfz(lastPosition, currentPosition);
          currentPosition = this.dfz(currentPosition);
          if (currentPosition === -1) {
            this.qft('EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.b2s(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.zfp_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).kfw = function () {
    var result = this.tfu();
    if (result === 'null' ? wasUnquotedString(this) : false) {
      this.qft("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).tfu = function () {
    if (!(this.bfq_1 == null)) {
      return takePeeked(this);
    }
    var current = this.jfz();
    if (current >= charSequenceLength(this.cfz()) ? true : current === -1) {
      this.qft('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.cfz(), current));
    if (token === 1) {
      return this.sfu();
    }
    if (!(token === 0)) {
      this.qft('Expected beginning of the string, but got ' + new Char(charSequenceGet(this.cfz(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.cfz(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.cfz())) {
        usedAppend = true;
        this.bfz(this.zfp_1, current);
        var eof = this.dfz(current);
        if (eof === -1) {
          this.zfp_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.b2s(this.zfp_1, current);
    } else {
      tmp = decodedString(this, this.zfp_1, current);
    }
    var result = tmp;
    this.zfp_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).bfz = function (fromIndex, toIndex) {
    this.cfq_1.ik(this.cfz(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).ifw = function (allowLenientStrings) {
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList_init_$Create$();
    var tokenStack = tmp$ret$0;
    var lastToken = this.qfu();
    if (!(lastToken === 8) ? !(lastToken === 6) : false) {
      this.tfu();
      return Unit_getInstance();
    }
    $l$loop: while (true) {
      lastToken = this.qfu();
      if (lastToken === 1) {
        if (allowLenientStrings) {
          this.tfu();
        } else {
          this.jfw();
        }
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 ? true : tmp0_subject === 6) {
        tokenStack.b(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.zfp_1, 'found ] instead of } at path: ' + this.afq_1, this.cfz());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.zfp_1, 'found } instead of ] at path: ' + this.afq_1, this.cfz());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.qft('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.ufu();
      if (tokenStack.l() === 0)
        return Unit_getInstance();
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + this.cfz() + "', currentPosition=" + this.zfp_1 + ')';
  };
  protoOf(AbstractJsonLexer).hfw = function (key) {
    var processed = this.b2s(0, this.zfp_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.ifz("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).ifz = function (message, position, hint) {
    var tmp;
    var tmp$ret$0;
    // Inline function 'kotlin.text.isEmpty' call
    tmp$ret$0 = charSequenceLength(hint) === 0;
    if (tmp$ret$0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.afq_1.dfu() + hintMessage, this.cfz());
  };
  protoOf(AbstractJsonLexer).qft = function (message, position, hint, $super) {
    position = position === VOID ? this.zfp_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.ifz(message, position, hint) : $super.ifz.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).tfw = function () {
    var current = this.jfz();
    current = this.dfz(current);
    if (current >= charSequenceLength(this.cfz()) ? true : current === -1) {
      this.qft('EOF');
    }
    var tmp;
    if (equals(new Char(charSequenceGet(this.cfz(), current)), new Char(_Char___init__impl__6a9atx(34)))) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.cfz())) {
        this.qft('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var isNegative = false;
    var start = current;
    var hasChars = true;
    $l$loop_0: while (hasChars) {
      var ch = charSequenceGet(this.cfz(), current);
      if (equals(new Char(ch), new Char(_Char___init__impl__6a9atx(45)))) {
        if (!(current === start)) {
          this.qft("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_0;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_0;
      current = current + 1 | 0;
      hasChars = !(current === charSequenceLength(this.cfz()));
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.qft("Unexpected symbol '" + new Char(ch) + "' in numeric literal");
      }
      var tmp$ret$1;
      // Inline function 'kotlin.Long.minus' call
      var tmp$ret$0;
      // Inline function 'kotlin.Long.times' call
      var tmp0_times = accumulator;
      tmp$ret$0 = tmp0_times.ta(new Long(10, 0));
      var tmp1_minus = tmp$ret$0;
      tmp$ret$1 = tmp1_minus.l1(toLong_0(digit));
      accumulator = tmp$ret$1;
      if (accumulator.k1(new Long(0, 0)) > 0) {
        this.qft('Numeric value overflow');
      }
    }
    if (start === current ? true : isNegative ? start === (current - 1 | 0) : false) {
      this.qft('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.qft('EOF');
      }
      if (!equals(new Char(charSequenceGet(this.cfz(), current)), new Char(_Char___init__impl__6a9atx(34)))) {
        this.qft('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.zfp_1 = current;
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else {
      var tmp_1 = accumulator;
      Companion_getInstance_4();
      if (!tmp_1.equals(new Long(0, -2147483648))) {
        tmp_0 = accumulator.a9();
      } else {
        this.qft('Numeric value overflow');
      }
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).rfw = function () {
    return consumeBoolean(this, this.jfz());
  };
  protoOf(AbstractJsonLexer).sfw = function () {
    var current = this.jfz();
    if (current === charSequenceLength(this.cfz())) {
      this.qft('EOF');
    }
    var tmp;
    if (equals(new Char(charSequenceGet(this.cfz(), current)), new Char(_Char___init__impl__6a9atx(34)))) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean(this, current);
    if (hasQuotation) {
      if (this.zfp_1 === charSequenceLength(this.cfz())) {
        this.qft('EOF');
      }
      if (!equals(new Char(charSequenceGet(this.cfz(), this.zfp_1)), new Char(_Char___init__impl__6a9atx(34)))) {
        this.qft('Expected closing quotation mark');
      }
      var tmp0_this = this;
      tmp0_this.zfp_1 = tmp0_this.zfp_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    var tmp$ret$0;
    // Inline function 'kotlin.code' call
    tmp$ret$0 = Char__toInt_impl_vasixd(c);
    if (tmp$ret$0 < 126) {
      var tmp_0 = CharMappings_getInstance().lfz_1;
      var tmp$ret$1;
      // Inline function 'kotlin.code' call
      tmp$ret$1 = Char__toInt_impl_vasixd(c);
      tmp = tmp_0[tmp$ret$1];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function get_TC_WHITESPACE() {
    return TC_WHITESPACE;
  }
  var TC_WHITESPACE;
  function get_TC_EOF() {
    return TC_EOF;
  }
  var TC_EOF;
  function get_STRING() {
    return STRING;
  }
  var STRING;
  function get_TC_STRING() {
    return TC_STRING;
  }
  var TC_STRING;
  function get_STRING_ESC() {
    return STRING_ESC;
  }
  var STRING_ESC;
  function get_TC_BEGIN_OBJ() {
    return TC_BEGIN_OBJ;
  }
  var TC_BEGIN_OBJ;
  function get_TC_COLON() {
    return TC_COLON;
  }
  var TC_COLON;
  function get_TC_COMMA() {
    return TC_COMMA;
  }
  var TC_COMMA;
  function get_COLON() {
    return COLON;
  }
  var COLON;
  function get_BEGIN_OBJ() {
    return BEGIN_OBJ;
  }
  var BEGIN_OBJ;
  function get_END_OBJ() {
    return END_OBJ;
  }
  var END_OBJ;
  function get_BEGIN_LIST() {
    return BEGIN_LIST;
  }
  var BEGIN_LIST;
  function get_END_LIST() {
    return END_LIST;
  }
  var END_LIST;
  function get_lenientHint() {
    return lenientHint;
  }
  var lenientHint;
  function get_INVALID() {
    return INVALID;
  }
  var INVALID;
  function get_COMMA() {
    return COMMA;
  }
  var COMMA;
  function get_NULL() {
    return NULL;
  }
  var NULL;
  function get_TC_END_OBJ() {
    return TC_END_OBJ;
  }
  var TC_END_OBJ;
  function get_TC_BEGIN_LIST() {
    return TC_BEGIN_LIST;
  }
  var TC_BEGIN_LIST;
  function get_TC_END_LIST() {
    return TC_END_LIST;
  }
  var TC_END_LIST;
  function get_TC_OTHER() {
    return TC_OTHER;
  }
  var TC_OTHER;
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().kfz_1[c] : _Char___init__impl__6a9atx(0);
  }
  function get_ignoreUnknownKeysHint() {
    return ignoreUnknownKeysHint;
  }
  var ignoreUnknownKeysHint;
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!equals(new Char(esc), new Char(_Char___init__impl__6a9atx(117)))) {
      var tmp$ret$0;
      // Inline function 'kotlin.code' call
      tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.kfz_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    var tmp$ret$0;
    // Inline function 'kotlin.code' call
    tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.lfz_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    var tmp$ret$0;
    // Inline function 'kotlin.code' call
    tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.kfz_1 = charArray(117);
    this.lfz_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function get_specialFlowingValuesHint() {
    return specialFlowingValuesHint;
  }
  var specialFlowingValuesHint;
  function get_allowStructuredMapKeysHint() {
    return allowStructuredMapKeysHint;
  }
  var allowStructuredMapKeysHint;
  function StringJsonLexer(source) {
    AbstractJsonLexer.call(this);
    this.qfz_1 = source;
  }
  protoOf(StringJsonLexer).cfz = function () {
    return this.qfz_1;
  };
  protoOf(StringJsonLexer).dfz = function (position) {
    return position < this.qfz_1.length ? position : -1;
  };
  protoOf(StringJsonLexer).ufu = function () {
    var source = this.qfz_1;
    $l$loop: while (!(this.zfp_1 === -1) ? this.zfp_1 < source.length : false) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.zfp_1;
      tmp0_this.zfp_1 = tmp1 + 1 | 0;
      var ch = charSequenceGet(source, tmp1);
      var tc = charToTokenClass(ch);
      var tmp;
      if (tc === get_TC_WHITESPACE()) {
        continue $l$loop;
      } else {
        tmp = tc;
      }
      return tmp;
    }
    return get_TC_EOF();
  };
  protoOf(StringJsonLexer).efw = function () {
    var current = this.jfz();
    if (current === this.qfz_1.length ? true : current === -1)
      return false;
    if (equals(new Char(charSequenceGet(this.qfz_1, current)), new Char(_Char___init__impl__6a9atx(44)))) {
      var tmp0_this = this;
      tmp0_this.zfp_1 = tmp0_this.zfp_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(StringJsonLexer).rfu = function () {
    var current = this.zfp_1;
    if (current === -1)
      return false;
    $l$loop: while (current < this.qfz_1.length) {
      var c = charSequenceGet(this.qfz_1, current);
      if (((equals(new Char(c), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(10)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(9)))) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.zfp_1 = current;
      return this.ffz(c);
    }
    this.zfp_1 = current;
    return false;
  };
  protoOf(StringJsonLexer).jfz = function () {
    var current = this.zfp_1;
    if (current === -1)
      return current;
    $l$loop: while (current < this.qfz_1.length) {
      var c = charSequenceGet(this.qfz_1, current);
      if (((equals(new Char(c), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(10)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(9)))) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.zfp_1 = current;
    return current;
  };
  protoOf(StringJsonLexer).dfw = function (expected) {
    if (this.zfp_1 === -1) {
      this.hfz(expected);
    }
    var source = this.qfz_1;
    $l$loop: while (this.zfp_1 < source.length) {
      var tmp0_this = this;
      var tmp1 = tmp0_this.zfp_1;
      tmp0_this.zfp_1 = tmp1 + 1 | 0;
      var c = charSequenceGet(source, tmp1);
      if (((equals(new Char(c), new Char(_Char___init__impl__6a9atx(32))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(10)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(13)))) ? true : equals(new Char(c), new Char(_Char___init__impl__6a9atx(9))))
        continue $l$loop;
      if (equals(new Char(c), new Char(expected)))
        return Unit_getInstance();
      this.hfz(expected);
    }
    this.hfz(expected);
  };
  protoOf(StringJsonLexer).jfw = function () {
    this.dfw(get_STRING());
    var current = this.zfp_1;
    var closingQuote = indexOf(this.qfz_1, _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.gfz(get_TC_STRING());
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(new Char(charSequenceGet(this.qfz_1, i)), new Char(get_STRING_ESC()))) {
          return this.consumeString2(this.qfz_1, this.zfp_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.zfp_1 = closingQuote + 1 | 0;
    var tmp$ret$1;
    // Inline function 'kotlin.text.substring' call
    var tmp0_substring = this.qfz_1;
    var tmp$ret$0;
    // Inline function 'kotlin.js.asDynamic' call
    tmp$ret$0 = tmp0_substring;
    tmp$ret$1 = tmp$ret$0.substring(current, closingQuote);
    return tmp$ret$1;
  };
  protoOf(StringJsonLexer).lfw = function (keyToMatch, isLenient) {
    var positionSnapshot = this.zfp_1;
    try {
      if (!(this.ufu() === get_TC_BEGIN_OBJ()))
        return null;
      var firstKey = isLenient ? this.jfw() : this.kfw();
      if (firstKey === keyToMatch) {
        if (!(this.ufu() === get_TC_COLON()))
          return null;
        var result = isLenient ? this.sfu() : this.kfw();
        return result;
      }
      return null;
    }finally {
      this.zfp_1 = positionSnapshot;
    }
  };
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.nfp_1;
  }
  function JsonToStringWriter() {
    this.qfp_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).xfs = function (value) {
    this.qfp_1.ac(value);
  };
  protoOf(JsonToStringWriter).rfs = function (char) {
    this.qfp_1.ib(char);
  };
  protoOf(JsonToStringWriter).tfs = function (text) {
    this.qfp_1.bc(text);
  };
  protoOf(JsonToStringWriter).dft = function (text) {
    printQuoted(this.qfp_1, text);
  };
  protoOf(JsonToStringWriter).dv = function () {
    this.qfp_1.kk();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.qfp_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).zf6 = get_isNullable;
  protoOf(defer$1).ff7 = get_isInline;
  protoOf(defer$1).df7 = get_annotations;
  protoOf(PolymorphismValidator).efp = contextual;
  protoOf(StreamingJsonDecoder).mf9 = decodeSerializableElement$default;
  protoOf(StreamingJsonDecoder).pf9 = decodeSequentially;
  protoOf(StreamingJsonDecoder).rf9 = decodeCollectionSize;
  protoOf(JsonDecoderForUnsignedTypes).yf8 = decodeSerializableValue;
  protoOf(JsonDecoderForUnsignedTypes).mf9 = decodeSerializableElement$default;
  protoOf(JsonDecoderForUnsignedTypes).pf9 = decodeSequentially;
  protoOf(JsonDecoderForUnsignedTypes).rf9 = decodeCollectionSize;
  protoOf(StreamingJsonEncoder).ufa = encodeNotNullMark;
  protoOf(StreamingJsonEncoder).vfa = beginCollection;
  protoOf(StreamingJsonEncoder).tfa = encodeNullableSerializableValue;
  protoOf(AbstractJsonTreeDecoder).mf9 = decodeSerializableElement$default;
  protoOf(AbstractJsonTreeDecoder).pf9 = decodeSequentially;
  protoOf(AbstractJsonTreeDecoder).rf9 = decodeCollectionSize;
  protoOf(JsonTreeDecoder).mf9 = decodeSerializableElement$default;
  protoOf(JsonTreeDecoder).pf9 = decodeSequentially;
  protoOf(JsonTreeDecoder).rf9 = decodeCollectionSize;
  protoOf(JsonTreeListDecoder).mf9 = decodeSerializableElement$default;
  protoOf(JsonTreeListDecoder).pf9 = decodeSequentially;
  protoOf(JsonTreeListDecoder).rf9 = decodeCollectionSize;
  protoOf(JsonPrimitiveDecoder).mf9 = decodeSerializableElement$default;
  protoOf(JsonPrimitiveDecoder).pf9 = decodeSequentially;
  protoOf(JsonPrimitiveDecoder).rf9 = decodeCollectionSize;
  protoOf(JsonTreeMapDecoder).mf9 = decodeSerializableElement$default;
  protoOf(JsonTreeMapDecoder).pf9 = decodeSequentially;
  protoOf(JsonTreeMapDecoder).rf9 = decodeCollectionSize;
  //endregion
  //region block: init
  PRIMITIVE_TAG = 'primitive';
  TC_WHITESPACE = 3;
  TC_EOF = 10;
  STRING = _Char___init__impl__6a9atx(34);
  TC_STRING = 1;
  STRING_ESC = _Char___init__impl__6a9atx(92);
  TC_BEGIN_OBJ = 6;
  TC_COLON = 5;
  TC_COMMA = 4;
  COLON = _Char___init__impl__6a9atx(58);
  BEGIN_OBJ = _Char___init__impl__6a9atx(123);
  END_OBJ = _Char___init__impl__6a9atx(125);
  BEGIN_LIST = _Char___init__impl__6a9atx(91);
  END_LIST = _Char___init__impl__6a9atx(93);
  lenientHint = "Use 'isLenient = true' in 'Json {}` builder to accept non-compliant JSON.";
  INVALID = _Char___init__impl__6a9atx(0);
  COMMA = _Char___init__impl__6a9atx(44);
  NULL = 'null';
  TC_END_OBJ = 7;
  TC_BEGIN_LIST = 8;
  TC_END_LIST = 9;
  TC_OTHER = 0;
  ignoreUnknownKeysHint = "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.";
  specialFlowingValuesHint = "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'";
  allowStructuredMapKeysHint = "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.";
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Default_getInstance;
  _.$_$.b = Json_0;
  //endregion
  return _;
}));
